import React, { useEffect, useContext, useState, useRef, useCallback, useMemo } from "react";
import { NavLink, useHistory } from "react-router-dom";
//axios and base url
import axios from "axios";
import moment from "moment";
import { BASE_URL } from "../../../../BaseUrl";
//functions
import {
  _t,
  getCookie,
  checkPermission,
  pageLoading,
  paginationLoading,
  pagination,
  showingData,
  searchedShowingData,
  getSystemSettings,
  maxLoyaltyPoint,
  checkNetworkStatus,
  getLoyaltyPoint,
  setApiTime,
  isTimeExpired,
  encryptAES128,
  getDisableLoyality,
  getLoyaltyItemsInfo,
  verifyAndFetchLoyalty,
  syncLoyaltyAndSendOTP,
  fetchVerifyOTP,
  getCustomerRegInfo,
  handleCardTransaction,
  processPaymentIntegrations,
  fetchOrderData,
  toastObj,
} from "../../../../functions/Functions";
import { getDiscount, getTax, applyItemLoyaltyPoints, updateLoyaltyPoints } from "./newpos/helpers";
import { useCustomHooks } from "../../../../functions/Hooks";
import { useTranslation } from "react-i18next";
import { TiArrowSortedUp } from "react-icons/ti";
import LoyaltyImg from "../../public/loyalty.png";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { useReactToPrint } from "react-to-print";
import SplitPayment from "./newpos/ItemModal/SplitPayment";
//importing context consumer here
import { UserContext } from "../../../../contexts/User";
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CardModal from "./modal/CardModal";
import RiderModal from "./modal/RiderModal";
import ItemCancelModal from "./modal/ItemCancelModal";
import OrderPrintView from "./modal/OrderPrintView";
import OrderDetailsView from "./modal/OrderDetailsView";
import WaiterChangeModal from "./modal/WaiterChangeModal";
import MultiSettleModal from "./modal/MultiSettleModal";
import PrintPaymentModal from "./modal/PrintPaymentModal";
import SplitBill from "./modal/SplitBill";
import { FaSearch } from "react-icons/fa";
import { BiDish } from "react-icons/bi";
import { MdDeliveryDining, MdVpnKey } from "react-icons/md";
import UpdateDeliveryChargeModal from "./modal/UpdateDeliveryChargeModal";
import UpdateDeviceTokenModal from "./modal/UpdateDeviceTokenModal";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import { ToastDismiss, ToastError } from "../../../../functions/ToastShow";
import { useCommonHooks } from "../../../../hooks/CommonHooks";
import useFOCManagerVerify from "../../../../hooks/useFOCManagerVerify";
import OrderCustomerDetail from "./newpos/ItemModal/OrderCustomerDetail";
import { useGeneralHooks } from "../../../../hooks/generalHooks";

const Submitted = () => {
  const { authUserInfo, getDeliveryUser, managerPasscode, waiterForSearch, deliveryListReqForSearch } = useContext(UserContext);
  const { availableDeliveryTypes } = useCommonHooks();
  const { onlineOrderEdit, multiOrderSettle } = useGeneralHooks();
  //getting context values here
  const {
    syncOrder,
    generalSettings,
  } = useContext(SettingsContext);

  const {
    //common
    loading,
    setLoading,

    //submitted orders
    submittedOrders,
    setPaginatedSubmittedOrders,
    submittedOrdersForSearch,

    //payment-type
    paymentTypeForSearch,
    //pagination
    dataPaginating,
    setDataPaginating,
    workPeriodListForBranch,
  } = useContext(RestaurantContext);

  const { t } = useTranslation();
  let history = useHistory();
  const { multiplyAddon, roundFormatPrice, roundOffPrice, getOfflineApiUrl, syncLocalOrders, debouncedFetchResults, setCardItemInclusiveSettle, getBeforeTaxPricePayment,getDynamicOfflinePrintUrl, firebaseAuth, firebaseAuthSetData } = useCustomHooks();

  //print bills
  const componentRef = useRef();
  const component2Ref = useRef();
  const searchInputRef = useRef();

  // States hook here
  const deliveryStatusOption = [
    {
      id: 1,
      name: "Assign a Rider",
    },
    {
      id: 2,
      name: "Pick Up",
    },
    {
      id: 3,
      name: "On the Way",
    },
  ];

  const [deliveryStatus, setDeliveryStatus] = useState(deliveryStatusOption[0]);

  const [splitBill, setSplitBill] = useState({});
  const [billModal, setBillModal] = useState({
    modal: false,
    currentState: null,
    orderDetail: null,
    originalItem: null,
    currentItem: null,
  });
  // show settle
  const [showSettle, setShowSettle] = useState(false);

  // paidMoney
  const [paidMoney, setPaidMoney] = useState(0);

  // SETpaidMoney
  const [totalAmount, setTotalAmount] = useState(0);

  // tax amount
  const [taxAmount, setTaxAmount] = useState(0);

  // tax %
  const [taxPercent, setTaxPercent] = useState(0);

  //return money
  const [returnMoneyUsd, setReturnMoneyUsd] = useState(0);

  //check tax
  const [checkStatus, setCheckStatus] = useState(false);

  // rider modal
  const [riderModal, setRiderModal] = useState(false);
  const [deliveryChargeModalItem, setDeliveryChargeModalItem] = useState(null);
  const [deviceTokenModalItem, setDeviceTokenModalItem] = useState(null);

  //settle order
  const [checkOrderDetails, setCheckOrderDetails] = useState({
    item: null,
    settle: false,
    uploading: false,
    payment_type: null,
    payment_amount: null,
    card_number: "",
    order_payment_bank: null,
  });

  const [loyaltyPoint, setloyaltyPoint] = useState({
    qr_code: "",
    availablePoints: 0,
    earnedPoints: 0,
    redeemPoints: 0,
    phn_no: "",
    verified: true,
    type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "" : "token",
    maxRedeemPoints: "",
    customerName: ""
  });
  //kot print
  const [foodGroupsToPrint, setFoodGroupsToPrint] = useState(null);
  const [selectedKot, setSelectedKot] = useState({});
  const [kotPrintIdx, setKotPrintIdx] = useState(0);

  //search result
  const [searchedOrder, setSearchedOrder] = useState({
    list: null,
    searched: false,
  });

  //split payment
  const [payModal, setPayModal] = useState(false);
  const [payment, setPayment] = useState("");
  const [paySelected, setPaySelected] = useState(null);

  //change waiter
  const [changeWaiter, setChangeWaiter] = useState({
    waiterSelected: null,
    id: null,
    modal: false,
    searchWaiter: null,
    waiters: null,
  });

  //FBR Invoice Num
  const [fbrInvoiceNum, setFbrInvoiceNum] = useState(null);
  //SRB Invoice Num
  const [srbInvoiceNum, setSrbInvoiceNum] = useState({
    number: "",
    url: "",
  });
  const isSettle = useRef(0);
  const [taxType, setTaxType] = useState("");
  const fbrNum = useRef(null);
  const srbNum = useRef({
    number: "",
    url: "",
  });

  //paymentTypeAvailable
  const [paymentTypeAvailable, setPaymentTypeAvailable] = useState(paymentTypeForSearch);
  const [activebtn, setActivebtn] = useState("");
  const [printPaymentModalItem, setPrintPaymentModalItem] = useState(null);
  const [orderFlowStatus, setOrderFlowStatus] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("pos_order_flow_status") || "{}");
    } catch (e) {
      return {};
    }
  });

  useEffect(() => {
    const updateReady = (id) => {
      if (!id) return;
      setOrderFlowStatus((prev) => ({ ...prev, [id]: "READY" }));
      try {
        const saved = JSON.parse(localStorage.getItem("pos_order_flow_status") || "{}");
        saved[id] = "READY";
        localStorage.setItem("pos_order_flow_status", JSON.stringify(saved));
      } catch (e) {}
      setPaginatedSubmittedOrders(1);
    };

    const handleStorage = (e) => {
      if (e.key === "pos_order_flow_status" && e.newValue) {
        try {
          setOrderFlowStatus((prev) => ({ ...prev, ...JSON.parse(e.newValue) }));
        } catch (err) {}
      } else if (e.key === "pos_order_ready" && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          if (data?.id) updateReady(data.id);
        } catch (err) {}
      }
    };
    // 1. Instant local storage listener (for same PC tab sync)
    window.addEventListener("storage", handleStorage);

    const branchId = authUserInfo?.details?.branch_id || localStorage.getItem("pos_selected_branch_id");
    const collection = generalSettings && getSystemSettings(generalSettings, "firebase_collection");
    let unsub = null;

    // 2. Cloud Firebase listener (cross-device sync with Kitchen and Order Screen)
    if (branchId && collection && firebaseAuth) {
      unsub = firebaseAuth(`pos/${collection}/order_tracker_screen/${branchId}`, (err, res) => {
        if (err || !res) return;
        const events = (res?.status || res?.order)
          ? [res]
          : typeof res === "object"
          ? Object.values(res).filter((v) => v && typeof v === "object")
          : [];
        events.forEach((ev) => {
          const st = String(ev?.status || ev?.order || "").toLowerCase();
          const id = ev?.order_id || ev?.orderId || ev?.id;
          if (st.includes("ready") && id) {
            updateReady(id);
          }
        });
      });
    }

    return () => {
      window.removeEventListener("storage", handleStorage);
      if (typeof unsub === "function") unsub();
      else if (unsub && typeof unsub.then === "function") unsub.then((fn) => typeof fn === "function" && fn());
    };
  }, [authUserInfo, generalSettings, firebaseAuth]);


  // passcode stuff
  const [passcodeApplied, setPasscodeApplied] = useState(false);
  const [deleteReasonModalShowing, setDeleteReasonModalShowing] =
    useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const feedbackRef = useRef(null);
  const orderDetailsRef = useRef(null);
  const cardAdd = useRef();
  const [cardNumber, setCardNumber] = useState({
    first: "******",
    middle: "****",
    last: "",
    order_payment_bank: null,
  });
  const inputRefs = {
    first: useRef(),
    middle: useRef(),
    last: useRef(),
    paid: useRef(),
  };

  const checkDeliveryFilter = useMemo(()=>{
    return activebtn === "Delivery"
  },[activebtn])

  const { openFOCManagerModal } = useFOCManagerVerify({
    loading,
    setLoading
  })

  // Filter state for checkboxes
  const [filterTypes, setFilterTypes] = useState({
    web: false,
    pos: false,
    app: false,
  });

  const [isCustomerUpdateModal, setIsCustomerUpdateModal] = useState(false);

  //totals
  const [showTotal, setShowTotal] = useState(false);
  const [multiSettleOrder, setMultiSettleOrder] = useState({
    orders: null,
    payment_type: null,
    modal: false,
    amount: 0,
  });
  
  // Helper to normalize request_from
  const getRequestType = (item) => {
    // Assuming request_from property exists, default to 'pos' if not found or empty
    const type = item.request_from ? item.request_from.toLowerCase() : "pos";
    if (type === "web") return "web";
    if (type === "app" || type === "mobile order") return "app";
    return "pos"; // Default to pos or handle specific 'pos' string
  };

  // Helper for background colors
  const getBackgroundColor = (type, isHeader = false) => {
    switch (type) {
      case "web":
        return isHeader ? "#e3f2fd" : "#e3f2fd"; // Light Blue
      case "app":
        return isHeader ? "#f3e2f6" : "#f3e2f6"; // Light Purple
      case "pos":
        return isHeader ? "#e3f6e4" : "#e3f6e4"; // Light Green
      default:
        return "transparent";
    }
  };

  // Helper for checkbox colors (darker shade)
  const getCheckboxColor = (type) => {
     switch (type) {
      case "web": return "#2196f3";
      case "app": return "#9c27b0";
      case "pos": return "#4caf50";
      default: return "";
    }
  };

  //go back 
  const handleGoBack = () => {
    setShowSettle(false);
    setPaySelected(null);
    setPaidMoney(0);
    setPayment("");
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    setCheckOrderDetails((curr) => ({
      ...curr,
      payment_type: null,
      card_number: "",
      order_payment_bank: null,
    }));
    setloyaltyPoint({
      qr_code: "",
      availablePoints: 0,
      earnedPoints: 0,
      redeemPoints: 0,
      phn_no: "",
      verified: true,
      type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "" : "token",
      maxRedeemPoints: "",
      customerName: ""
    })
  }

  const onSearchClear = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    setSearchedOrder({
      list: null,
      searched: false,
    });
    setMultiSettleOrder({
      orders: null,
      payment_type: null,
      modal: false,
    })
  }

  //change waiter
  const handleWaiterChange = (item) => {
    let waiter = null;
    let tempWaiters = [];
    waiterForSearch.forEach((eachWaiter) => {
      if (eachWaiter.id === item.waiter_id) {
        waiter = eachWaiter;
      }
      if (parseInt(eachWaiter.branch_id) === item.branch_id) {
        tempWaiters.push(eachWaiter);
      }
    });

    setChangeWaiter({
      waiterSelected: waiter,
      id: item.id,
      modal: true,
      searchWaiter: null,
      waiters: tempWaiters,
    })
  }

  // card number add
  const handleCardSubmit = (e) => {
    e.preventDefault();

    if (cardNumber.last?.length < (checkOrderDetails.payment_type?.[0]?.digit_required ?? 6)) {
      toast.error("Please enter valid card number");
      return false
    }

    const currentPaymentType = paySelected || checkOrderDetails.payment_type?.[0];
    if (Number(currentPaymentType?.bank_required) === 1 && !cardNumber.order_payment_bank) {
      toast.error(`${_t(t("Please select a bank"))}`);
      return false;
    }

    const cardNumberFinal = cardNumber.first + cardNumber.middle + cardNumber.last;
    setCheckOrderDetails({
      ...checkOrderDetails,
      card_number: cardNumberFinal,
      order_payment_bank: cardNumber.order_payment_bank,
    })

    cardAdd.current.classList.remove("showing");
  }

  useEffect(() => {
    if (showSettle) {
      setTimeout(() => {
        inputRefs.paid.current && inputRefs.paid.current.focus();
      }, 500);
    }
  }, [showSettle]);

  // redeem point
  const handleRedeemPoint = (e, availablepoints = 0) => {
    const value = Number(e.target.value);
    const maxAllowed = Number(loyaltyPoint.maxRedeemPoints) > 0
      ? Math.min(loyaltyPoint.maxRedeemPoints, loyaltyPoint.availablePoints)
      : (Number(loyaltyPoint.availablePoints) || availablepoints);
    const isValid = value <= maxAllowed;

    if (isValid) {
      setloyaltyPoint((curr) => ({
        ...curr,
        redeemPoints: value
      }));
      const totalAfterLoyalty = parseFloat(roundOffPrice(totalAmount)) -
        parseFloat(roundOffPrice(checkOrderDetails.item.paid_amount)) - Number(value)
      setCheckOrderDetails((curr) => ({
        ...curr,
        item: {
          ...curr.item,
          total_payable: totalAfterLoyalty,
        },
      }));
    }else{
      if(getSystemSettings(generalSettings, "loyality_enable") === "techmixers"){
        const checkCanRedeem = JSON.parse(sessionStorage.getItem("techloyalty"));
        if(checkCanRedeem && Number(checkCanRedeem?.rdmptn_limit_prcnt)){
          if(loyaltyPoint.maxRedeemPoints < loyaltyPoint.availablePoints){
            toast.error(`You are allowed to redeem ${checkCanRedeem?.rdmptn_limit_prcnt}% (Rs.${getDiscount(totalAmount,checkCanRedeem?.rdmptn_limit_prcnt)}) of sale amount`,{
              position: "bottom-center",
              closeButton: false,
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            return
          } else {
            toast.error(`You are allowed to redeem ${loyaltyPoint.availablePoints}.`, {
              position: "bottom-center",
              closeButton: false,
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            return
          }
        }
      }
      toast.error("You can't redeem more than your max points", {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      })
    }
  }

  //clear paid and 
  const handleClearAmount = () => {
    setPaidMoney(0);
    setReturnMoneyUsd(0);
    setPaySelected(null);
    setPayment("");
  }

  //loyalty points calculation
  const handleCalLoyaltyPoints = (total, taxPercent= (checkOrderDetails.item.theBranch.branch_tax ?? 0), items=null)=>{
    if(loyaltyPoint.redeemPoints && getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none"){
      if(sessionStorage.getItem("techloyalty") && (Math.min(loyaltyPoint.maxRedeemPoints,loyaltyPoint.availablePoints) === Number(loyaltyPoint.redeemPoints) ||
        Math.min(loyaltyPoint.maxRedeemPoints,loyaltyPoint?.points) === Number(loyaltyPoint.redeemPoints)) && Number(loyaltyPoint.redeemPoints)){
        let availPoints = 0;
        const res = JSON.parse(sessionStorage.getItem("techloyalty"));
        if(res.display_campaign_msg === "1" && Number(res.campaign_discount) > 0){
          availPoints = roundOffPrice(total * res.campaign_discount);
        }else if(Number(res.redemp_req_amt) > 0){
          availPoints = Number(res.redemp_req_amt) > Number(res.redeemable_amt) ? roundOffPrice(res.redeemable_amt) : roundOffPrice(res.redemp_req_amt);
        }else if(Number(res.rdmptn_limit_prcnt) > 0){
          availPoints = roundOffPrice(getDiscount(total, res.rdmptn_limit_prcnt));
        }else if(Number(res.redeemable_amt) > 0){
          availPoints = roundOffPrice(res.redeemable_amt);
        }
        if(availPoints && availPoints > total){
          availPoints = total
        }
        if(availPoints){
          availPoints = Math.min(availPoints,loyaltyPoint.availablePoints)
        }
        setloyaltyPoint((curr)=>({
          ...curr,
          redeemPoints: availPoints,
          points: availPoints,
        }))
        return availPoints;
      }else if(getSystemSettings(generalSettings, "loyality_enable") === "techmixers"){
        if(Number(loyaltyPoint.redeemPoints) > total){
          setloyaltyPoint((curr)=>({
            ...curr,
            redeemPoints: total,
            maxRedeemPoints: total,
          }))
          return total
        }
        return Number(loyaltyPoint.redeemPoints);
      } else if (getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise") {
        if (getSystemSettings(generalSettings, "tax_type") === "inclusive") {
          const point = roundOffPrice(updateLoyaltyPoints(items ?? checkOrderDetails.item.orderedItems, taxPercent));
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: point,
            maxRedeemPoints: point,
          }))
          return point;
        }
        return Number(loyaltyPoint.redeemPoints);
      } else {
        const points = maxLoyaltyPoint(total);
        if ((points > 0 && points < loyaltyPoint.redeemPoints && loyaltyPoint.maxRedeemPoints === loyaltyPoint.redeemPoints && points > loyaltyPoint.maxRedeemPoints)) {
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: points,
            maxRedeemPoints: points,
          }))
          return points;
        } else if (points > 0 && loyaltyPoint.availablePoints < points && loyaltyPoint.maxRedeemPoints === loyaltyPoint.redeemPoints) {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: points,
            redeemPoints: loyaltyPoint.availablePoints,
          }))
          return Number(loyaltyPoint.availablePoints);
        } else {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: points,
          }))
          return Number(loyaltyPoint.redeemPoints)
        }
      }
    }
    return 0
  }

  //clear settle amount
  const handleClearAll = () => {
    handleClearAmount();
    let total = parseFloat(roundOffPrice(totalAmount)) - parseFloat(roundOffPrice(checkOrderDetails.item.paid_amount));

    if (getSystemSettings(generalSettings, "tax_type") === "inclusive" && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1 &&
      checkOrderDetails.payment_type && checkOrderDetails.item.theBranch.branch_tax !== checkOrderDetails.payment_type?.[0]?.tax_percent) {
      const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(checkOrderDetails.item.orderedItems, checkOrderDetails.payment_type?.[0]?.tax_percent || checkOrderDetails.item.theBranch.branch_tax, checkOrderDetails.item.theBranch.branch_tax);
      const calLoyaltyPoint = handleCalLoyaltyPoints(total, checkOrderDetails.item.theBranch.branch_tax, updatedCartItems);
      if (calLoyaltyPoint > 0) {
        total -= calLoyaltyPoint
      }
      setCheckOrderDetails((curr) => ({
        ...curr,
        item: {
          ...curr.item,
          orderedItems: updatedCartItems || curr.item.orderedItems,
          order_bill: roundOffPrice(subtotal),
          total_payable: total,
          vat: parseFloat(roundOffPrice(taxAmount))
        },
        payment_type: null,
        card_number: "",
        order_payment_bank: null,
      }));
    } else {
      const calLoyaltyPoint = handleCalLoyaltyPoints(total);
      if (calLoyaltyPoint > 0) {
        total -= calLoyaltyPoint
      }
      setCheckOrderDetails((curr) => ({
        ...curr,
        item: {
          ...curr.item,
          total_payable: total,
          vat: parseFloat(roundOffPrice(taxAmount))
        },
        payment_type: null,
        card_number: "",
        order_payment_bank: null,
      }));
    }
  }

  const handleCardChange = (part, value) => {
    setCardNumber((prev) => ({
      ...prev,
      [part]: value,
    }));

    // if(part === "first" && value?.length === 6){
    //   inputRefs.last.current.focus();
    //  }
  };

  // split pay on click
  const handleClick = () => {
    setPaidMoney(0);
    setReturnMoneyUsd(0);
    setPayment("");
    setPaySelected(null);
    setCheckOrderDetails({
      ...checkOrderDetails,
      payment_type: null,
      vat: checkOrderDetails.item?.vat
    });
    setPayModal(false)
  }

  //payment type select
  const handleSetPayment = (pay) => {
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    if (pay?.view_card === 1 || Number(pay?.bank_required) === 1) {
      cardAdd.current.classList += " showing";
      inputRefs.last.current.focus();
    }
    setPaySelected(pay)
  }

  const getCustomerInfo = async (value, isDirectHit = false) => {
    const params = {
      phn_no: value,
      branch: checkOrderDetails.item.theBranch,
    };
    let res = "";
    if (isDirectHit) {
      res = await getCustomerRegInfo(params, setDataPaginating)
    } else {
      res = await debouncedFetchResults(params, getCustomerRegInfo, setDataPaginating);
    }
    if (res) {
      if (res?.returnvalue == 0 && res.success) {
        let availPoints = 0;
        const checkCond = (res.display_campaign_msg === "1" && Number(res.campaign_discount)) || (Number(res.redemp_req_amt) > 0);
        if (res.display_campaign_msg === "1" && Number(res.campaign_discount) > 0) {
          availPoints = roundOffPrice(checkOrderDetails.item.total_payable * res.campaign_discount);
        } else if (Number(res.redemp_req_amt) > 0) {
          availPoints = Number(res.redemp_req_amt) > Number(res.redeemable_amt) ? roundOffPrice(res.redeemable_amt) : roundOffPrice(res.redemp_req_amt);
        } else if (Number(res.rdmptn_limit_prcnt) > 0) {
          availPoints = roundOffPrice(getDiscount(checkOrderDetails.item.total_payable, res.rdmptn_limit_prcnt));
        } else if (Number(res.redeemable_amt) > 0) {
          availPoints = roundOffPrice(res.redeemable_amt);
        }
        if(availPoints && availPoints > totalAmount){
          availPoints = totalAmount
        }
        setloyaltyPoint((curr)=>({
          ...curr,
          availablePoints: Number(res.redeemable_amt),
          earnedPoints: (res?.earned_points && Number(res.earned_points)) ?? 0,
          maxRedeemPoints: availPoints ? availPoints : Number(res.redeemable_amt),
          redeemPoints: checkCond ? availPoints : 0,
          verified: false,
          customerName: res?.cust_name || "",
        }));
        if (availPoints && checkCond) {
          const totalAfterLoyalty = parseFloat(roundOffPrice(totalAmount)) -
            parseFloat(roundOffPrice(checkOrderDetails.item.paid_amount)) - Number(availPoints)
          setCheckOrderDetails((curr) => ({
            ...curr,
            item: {
              ...curr.item,
              total_payable: totalAfterLoyalty,
            },
          }));
        }
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            customer_name: res.cust_name,
            email: res.cust_email,
            delivery_phn_no: res.pos_cust_phone,
          },
        }));

      } else {
        setloyaltyPoint((curr) => ({
          ...curr,
          availablePoints: 0,
          earnedPoints: 0,
          maxRedeemPoints: 0,
          redeemPoints: 0,
          verified: false,
        }))
      }
    }
  }

  //loyality toggle
  const handleToggle = async (option) => {
    if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
      setloyaltyPoint((curr) => ({
        ...curr,
        qr_code: curr.qr_code ?? "",
        type: option,
        redeemPoints: curr.qr_code ? curr.redeemPoints : 0,
      }));
      if (loyaltyPoint.phn_no?.length > 9 && option === "send-otp" && loyaltyPoint.type !== "send-otp") {
        const params = {
          phone: loyaltyPoint.phn_no,
          code: checkOrderDetails.item.theBranch?.code,
        }
        let result = await syncLoyaltyAndSendOTP(params, setDataPaginating);
      } else if (option === "get-info" && loyaltyPoint.type !== "get-info" && loyaltyPoint.phn_no?.length > 9) {
        getCustomerInfo(loyaltyPoint.phn_no, true);
      }
    } else {
      setloyaltyPoint((curr) => ({
        ...curr,
        qr_code: option === "phone" ? (checkOrderDetails.item?.delivery_phn_no) : "",
        type: option,
        availablePoints: 0,
        earnedPoints: 0,
        redeemPoints: 0,
        maxRedeemPoints: "",
        customerName: "",
      }));
    }
  };

  //get tech made loyalty points
  const handleGetLoyaltyChange = async (e) => {
    const { name, value } = e?.target;
    setloyaltyPoint((curr) => ({
      ...curr,
      [name]: value,
    }))
    if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
      if (loyaltyPoint.type !== "code" && loyaltyPoint.type !== "send-otp" && loyaltyPoint.type !== "get-info") {
        toast.error("Please select otp/info or code.", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      if (loyaltyPoint.type === "get-info" && value?.length > 9) {
        getCustomerInfo(value);
      } else if (loyaltyPoint.type === "code") {
        if (loyaltyPoint.phn_no?.length > 9 && e.target.name === "qr_code" && value?.length > 3) {
          const params = {
            phone: loyaltyPoint.phn_no,
            code: checkOrderDetails.item.theBranch?.code,
            otp_code: value,
          }
          let result = await debouncedFetchResults(params, fetchVerifyOTP, setDataPaginating);
          if (result && result.success && result.returnvalue == 0) {
            setloyaltyPoint((curr) => ({
              ...curr,
              verified: true,
            }))
          }
        }
      }
      // else if(loyaltyPoint.type === "send-otp"){
      //   if(value?.length > 9 && e.target.name === "phn_no"){
      //     const params = {
      //       phone: value,
      //       code: checkOrderDetails.item.theBranch?.code,
      //     }
      //     let result = await debouncedFetchResults(params, syncLoyaltyAndSendOTP, setDataPaginating);
      //   }
      // }
    }
  }

  // handle get loyalty indolj input change
  const handleGetIndoljChange = async (e) => {
    const value = e.target.value;
    setloyaltyPoint((curr) => ({
      ...curr,
      qr_code: value,
    }))
    if (value && (loyaltyPoint.type === "phone" ? (value?.length > 9) : (value?.length > 4))) {
      const params = {
        phone: value,
        code: loyaltyPoint.type,
      }
      if (getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise") {
        const newParams = {
          ...params,
          directSettle: false,
          items: checkOrderDetails.item.orderedItems
        }
        let result = await debouncedFetchResults(newParams, getLoyaltyItemsInfo, setDataPaginating);
        if (result) {
          const { items, points } = applyItemLoyaltyPoints(checkOrderDetails.item.orderedItems, getSystemSettings(generalSettings, "tax_type"), checkOrderDetails.item.theBranch.branch_tax, result);
          const roundedPoints = roundOffPrice(points);
          setCheckOrderDetails((curr) => ({
            ...curr,
            item: {
              ...curr.item,
              orderedItems: items,
              ...(!curr.item.delivery_phn_no && {
                delivery_phn_no: result.data?.client_info?.client_phone_number || curr.item.delivery_phn_no,
                customer_name: result.data?.client_info?.client_name ?? curr.item.customer_name,
              })
            },
          }))
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: roundedPoints,
            customerName: result.data?.client_info?.client_name || "",
            verified: false,
          }));
          handleRedeemPoint({ target: { name: "redeemPoints", value: roundedPoints } }, roundedPoints);
        } else {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: 0,
            customerName: "",
          }));
          handleRedeemPoint({ target: { name: "redeemPoints", value: 0 } }, 0);
        }
      } else {
        let result = await debouncedFetchResults(params, verifyAndFetchLoyalty, setLoading, checkOrderDetails.item.id);
        if (loyaltyPoint.type !== "phone" && !localStorage.getItem("loyalty")) {
          await getLoyaltyPoint();
        }
        if (result?.points >= 0) {
          setloyaltyPoint((curr) => ({
            ...curr,
            availablePoints: result.points,
            maxRedeemPoints: maxLoyaltyPoint(totalAmount),
            customerName: result?.customerName || "",
            verified: true,
          }))
        }
      }
      setLoading(false)
    }
  };

  //debounce
  const handleAutoSplitPayment = (value) => {
    const total = parseFloat(totalAmount) - parseFloat(checkOrderDetails.item.paid_amount);
    let remainingAmount = total - parseFloat(value);
    if (loyaltyPoint.redeemPoints) {
      remainingAmount -= Number(loyaltyPoint.redeemPoints);
    }
    if (remainingAmount > 0) {
      setPayment((prevPayment) => ({ ...prevPayment, select_split: roundOffPrice(remainingAmount) }));
    } else {
      setPayment((curr) => {
        const newData = {
          ...curr
        }
        newData["select_split"] && delete newData["select_split"]
        return newData
      });
    }
  }

  //split payment on chnage
  const handleSplitPayment = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    if (payment && (value == 0 || value === "")) {

      setPayment((curr) => {
        const newData = {
          ...curr
        }
        newData[id] && delete newData[id];
        if (!isNaN(Number(id))) {
          newData["select_split"] && delete newData["select_split"]
        }
        return newData
      });

    } else {
      setPayment((prevPayment) => ({ ...prevPayment, [id]: value }));
      if (!isNaN(Number(id))) {
        handleAutoSplitPayment(value);
      }
    }
  };

  //payment split type pos
  const handleSetpaymentTypeMuliple = (e) => {
    e.preventDefault();
    if (payment) {
      if (!paySelected) {
        toast.error(
          "Please select the payment type to split payment", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
        );
        return false;
      }
      if (!paySelected) {
        toast.error(
          "Please select the payment type to split payment", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
        );
        return false;
      }

      let total = 0;
      const paymentMethod = payment && Object?.keys(payment).map((id) => {
        const amount = parseFloat(payment[id]);
        const type = isNaN(Number(id)) ? paySelected : paymentTypeAvailable.find(payType => payType.id === Number(id));
        const taxAmount = (getBeforeTaxPricePayment(amount, checkOrderDetails.item.theBranch.branch_tax));
        total += amount;
        return {
          ...type,
          tax_percent: checkOrderDetails.item.theBranch.branch_tax,
          tax_amount: roundOffPrice(taxAmount),
          bill_amount: amount
        };
      });
      let localCurrency = JSON.parse(localStorage.getItem("currency"));
      let theUsdPaid = total / localCurrency.rate;

      let totalPay = totalAmount;
      if (loyaltyPoint.redeemPoints) {
        totalPay -= Number(loyaltyPoint.redeemPoints)
      }

      if (roundOffPrice(theUsdPaid) > roundOffPrice(totalPay - parseFloat(checkOrderDetails.item.paid_amount))) {
        setPayModal(true)
        setPaidMoney(0);
        setReturnMoneyUsd(0);
        setCheckOrderDetails({
          ...checkOrderDetails,
          item: {
            ...checkOrderDetails.item,
            total_payable: parseFloat(roundOffPrice(totalPay)) -
              parseFloat(roundOffPrice(checkOrderDetails.item.paid_amount)),
          },
        });

        toast.error(
          "Please enter paid amount exact equal to the total bill amount",
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        return false
      }
      if (roundOffPrice(theUsdPaid) < roundOffPrice(totalPay - parseFloat(checkOrderDetails.item.paid_amount))) {
        setPayModal(true)
        setReturnMoneyUsd(0);
        setPaidMoney(0);
        setCheckOrderDetails({
          ...checkOrderDetails,
          item: {
            ...checkOrderDetails.item,
            total_payable: parseFloat(roundOffPrice(totalPay)) -
              parseFloat(roundOffPrice(checkOrderDetails.item.paid_amount)),
          },
        });
        toast.error(
          "Please enter paid amount atleast equal to the total bill amount",
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      } else {
        setTaxPercent(checkOrderDetails.item.theBranch?.branch_tax);
        setPaidMoney(parseFloat(roundOffPrice(totalPay)));
        setPayModal(false);
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            total_payable: parseFloat(roundOffPrice(totalPay)) -
              parseFloat(roundOffPrice(curr.item.paid_amount)),
            vat: parseFloat(roundOffPrice(taxAmount)),
          },
          payment_type: paymentMethod,
        }));

        let theReturnMoney = theUsdPaid - parseFloat(totalPay) - parseFloat(checkOrderDetails.item.paid_amount);
        setReturnMoneyUsd(roundOffPrice(theReturnMoney));
      }

    } else {
      toast.error(
        "Please select the payment type to split payment",
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  useEffect(() => {
    if (!authUserInfo) return;
    setPasscodeApplied(
      authUserInfo.details.user_type === "staff" &&
        (authUserInfo.details.user_passcode || managerPasscode)
        ? true
        : false
      );
    if(isTimeExpired("deliveryUser")){
      getDeliveryUser();
      setApiTime("deliveryUser");
    }
  }, [authUserInfo]);

  // Initial fetch and synchronization for Order Screen
  useEffect(() => {
    setPaginatedSubmittedOrders(1);
  }, []);

  //useEffect == componentDidMount
  useEffect(() => {
    if (checkOrderDetails?.item?.associate_with_payment_type && checkOrderDetails?.item?.associate_with_payment_type !== "-") {
      const tempAvailablePaymentType = paymentTypeForSearch?.filter((item) => {
        return JSON.parse(checkOrderDetails?.item?.associate_with_payment_type)?.includes(
          item.id
        );
      });
      setPaymentTypeAvailable(tempAvailablePaymentType);
    }
  }, [checkOrderDetails.item]);

  function addToStorage(id) {
    const storageKey = "itemCounts"; // Key for sessionStorage
    let storage = JSON.parse(sessionStorage.getItem(storageKey)) || {};

    // Update the count for the given ID
    if (storage[id]) {
      storage[id] += 1;
    } else {
      storage[id] = 1;
    }
    // Save the updated storage back to sessionStorage
    sessionStorage.setItem(storageKey, JSON.stringify(storage));
  }

  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      if (!isSettle.current && orderDetailsRef.current?.item) {
        addToStorage(orderDetailsRef.current.item?.id);
      }
      handleSubmitSuccess();
    },
    removeAfterPrint: false,
  });

  // set kot print
  const handleKotItem = (items = null) => {
    const kotObj = {};
    let orderItems = [...(items || (orderDetailsRef.current?.item?.orderedItems))];
    const listItem = orderDetailsRef.current?.item || checkOrderDetails?.item;
    const consolidatedKot = listItem && (listItem.theBranch.consolidated_kot === "true" || parseInt(listItem.theBranch.consolidated_kot) === 1);
    const branchKot = listItem && listItem.theBranch?.consolidated_ip;
    orderItems.forEach((item) => {
      const obj = { ...item, print_status: "cancel" }
      const kotKey = obj?.kot_ip ? obj.kot_ip : "No";
      const groupKey = obj.food_group ? obj.food_group : "None";

      // branch wise consolidated kot
      if (consolidatedKot) {
        if (
          kotObj.hasOwnProperty(branchKot) &&
          kotObj[branchKot] &&
          Object.keys(kotObj[branchKot])?.length
        ) {
          if (
            kotObj[branchKot].hasOwnProperty(groupKey) &&
            kotObj[branchKot][groupKey] &&
            kotObj[branchKot][groupKey]?.length
          ) {
            kotObj[branchKot] = {
              ...kotObj[branchKot],
              [groupKey]: [...kotObj[branchKot][groupKey], { ...obj }],
            };
          } else {
            kotObj[branchKot] = {
              ...kotObj[branchKot],
              [groupKey]: [{ ...obj }],
            }
          }
        } else {
          kotObj[branchKot] = {
            // ...kotObj[branchKot],
            [groupKey]: [{ ...obj }],
          };
        }
      }

      if (obj?.is_special == "1" && obj?.properties !== "") {
        JSON.parse(obj.properties).forEach((prop) => {
          const kotProp = prop?.kot_ip
            ? prop.kot_ip : "No";
          const propItem = JSON.parse(JSON.stringify(prop));
          propItem.property = obj.food_item + " - " + propItem.property;

          if (
            kotObj[kotProp] &&
            kotObj.hasOwnProperty(kotProp) &&
            Object.keys(kotObj[kotProp])?.length
          ) {
            if (
              kotObj[kotProp].hasOwnProperty(groupKey) &&
              kotObj[kotProp][groupKey] &&
              kotObj[kotProp][groupKey]?.length
            ) {
              kotObj[kotProp] = {
                ...kotObj[kotProp],
                [groupKey]: [...kotObj[kotProp][groupKey], { ...obj, property: { ...propItem } }],
              };

            } else {
              kotObj[kotProp] = {
                ...kotObj[kotProp],
                [groupKey]: [{ ...obj, property: { ...propItem } }],
              };
            }
          } else {
            kotObj[kotProp] = {
              [groupKey]: [{ ...obj, property: { ...propItem } }],
            };
          }
        });
      } else {
        // item wise kot
        if (
          kotObj.hasOwnProperty(kotKey) &&
          kotObj[kotKey] &&
          Object.keys(kotObj[kotKey])?.length
        ) {
          if (
            kotObj[kotKey].hasOwnProperty(groupKey) &&
            kotObj[kotKey][groupKey] &&
            kotObj[kotKey][groupKey]?.length
          ) {
            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [...kotObj[kotKey][groupKey], { ...obj }],
            };

          } else {
            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [{ ...obj }],
            };
          }
        } else {
          kotObj[kotKey] = {
            [groupKey]: [{ ...obj }],
          };
        }
      }
    });
    setSelectedKot(kotObj);
    return kotObj;
  }

  const handleOnlyPrint2 = useReactToPrint({
    content: () => component2Ref.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      setNextKotPrint();
    },
    removeAfterPrint: false,
  });

  //All Receipt Control from this handle
  const getCurrentSelectedKots = useRef();
  getCurrentSelectedKots.current = selectedKot;
  const getCurrentKotPrintIndex = useRef();
  getCurrentKotPrintIndex.current = kotPrintIdx;

  const handlePrintAll = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      if (getSystemSettings(generalSettings, "print_kitchen_bill") === "1") {
        let kots = getCurrentSelectedKots.current;
        if (kots && Object.keys(kots)?.length) {
          setNextKotPrint();
        } else {
          handleSubmitSuccess();
        }
      } else {
        handleSubmitSuccess();
      }
    },
    removeAfterPrint: false,
  });

  const handlePrintCondition = () => {
    switch ((checkOrderDetails.item && checkOrderDetails.item.theBranch?.print_pos_setting) ? checkOrderDetails.item.theBranch.print_pos_setting :
      getSystemSettings(generalSettings, "print_pos_setting")) {
      case "Customer":
        handleOnlyPrint();
        break;

      case "Kitchen":
        setNextKotPrint();;
        break;

      default:
        handlePrintAll();
        break;
    }
  }

  /* KOT PRINTING FUNCTION */
  const setNextKotPrint = () => {
    let currentKotIdx = getCurrentKotPrintIndex.current;
    let allKots = getCurrentSelectedKots.current;
    setKotPrintIdx((curr) => curr + 1);
    if (currentKotIdx === Object.keys(allKots).length) {
      handleSubmitSuccess();
    } else {
      const newNewOrder = Object.values(allKots)[currentKotIdx];
      setFoodGroupsToPrint(newNewOrder);
      handleOnlyPrint2();
    }
  };

  useEffect(() => {
    if (!generalSettings || !Object.keys(generalSettings)?.length) return;
    setTaxType(getSystemSettings(generalSettings, "tax_type"));
  }, [generalSettings]);

  //payment type
  const handleSetpaymentType = (payment_type) => {
    setCheckOrderDetails({
      ...checkOrderDetails,
      payment_type,
      card_number: "",
      order_payment_bank: null,
    });

    //calculate paid amount to set return amount
    handleCalculatePaid(checkOrderDetails.payment_amount, payment_type);
  };

  //payment type for screen 2
  const handleSetpaymentTypeSingle = (payment_type) => {
    let b_tax = checkOrderDetails.item?.payment_tax[payment_type.name];
    if (payment_type?.view_card === 1 || Number(payment_type?.bank_required) === 1) {
      cardAdd.current.classList += " showing";
      inputRefs.last.current.focus();
    }
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    setPaySelected(null);
    setPayment("");

    let inclusive_vat = 0;
    let previous_amount = 0;
    let new_amount = 0;
    let localCurrency = JSON.parse(localStorage.getItem("currency"));

    if (getSystemSettings(generalSettings, "tax_type") === "inclusive" && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1) {
      let total = totalAmount;
      let items = checkOrderDetails.item.orderedItems;
      if (!checkOrderDetails.item?.is_advance_booking && b_tax > 0 && b_tax !== checkOrderDetails.item.theBranch.branch_tax) {
        setTaxPercent(b_tax);
        setCheckStatus(true);
        const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(checkOrderDetails.item.orderedItems, checkOrderDetails.payment_type?.[0]?.tax_percent || checkOrderDetails.item.theBranch.branch_tax, b_tax);
        const getVat = roundOffPrice(getTax(b_tax, subtotal));
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            orderedItems: updatedCartItems,
            vat: roundOffPrice(getVat),
            order_bill: roundOffPrice(subtotal),
            total_payable: roundOffPrice(total),
          },
          payment_type: [{ ...payment_type, bill_amount: roundOffPrice(total), tax_percent: b_tax, tax_amount: roundOffPrice(getVat) }],
          card_number: "",
          order_payment_bank: null,
        }));
      } else {
        setTaxPercent(checkOrderDetails.item.theBranch.branch_tax);
        const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(checkOrderDetails.item.orderedItems, checkOrderDetails.payment_type?.[0]?.tax_percent || checkOrderDetails.item.theBranch.branch_tax, checkOrderDetails.item.theBranch.branch_tax);
        items = updatedCartItems;
        const getVat = roundOffPrice(getTax(checkOrderDetails.item.theBranch.branch_tax, subtotal));
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            orderedItems: updatedCartItems,
            vat: roundOffPrice(getVat),
            order_bill: roundOffPrice(subtotal),
            total_payable: roundOffPrice(total),
          },
          payment_type: [{ ...payment_type, bill_amount: roundOffPrice(total), tax_percent: curr.item.theBranch.branch_tax, tax_amount: roundOffPrice(getVat) }],
          card_number: "",
          order_payment_bank: null,
        }));
      }
      const calLoyaltyPoint = handleCalLoyaltyPoints(total, checkOrderDetails.item.theBranch.branch_tax, items);
      if (calLoyaltyPoint > 0) {
        total -= calLoyaltyPoint
      }
      setPaidMoney(parseFloat(roundOffPrice(total)));
    } else {
      if (!checkOrderDetails.item?.is_advance_booking && b_tax && b_tax >= 0) {
        let vatCalculate = getSystemSettings(generalSettings, "tax_type_discount") === "tax_discount_after" ? (parseFloat(checkOrderDetails.item.order_bill) - parseFloat(checkOrderDetails.item.discount_amount)) : parseFloat(checkOrderDetails.item.order_bill);
        inclusive_vat = vatCalculate * (parseFloat(b_tax) / 100);
        previous_amount = parseFloat(totalAmount) - parseFloat(taxAmount);
        new_amount = previous_amount + inclusive_vat;

        const calLoyaltyPoint = handleCalLoyaltyPoints(new_amount, b_tax);
        if (calLoyaltyPoint > 0) {
          new_amount -= calLoyaltyPoint
        }
        setTaxPercent(b_tax);
        setCheckStatus(true);
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            total_payable: roundOffPrice(new_amount),
            vat: roundOffPrice(inclusive_vat),
          },
          payment_type: [{ ...payment_type, bill_amount: roundOffPrice(new_amount), tax_percent: b_tax, tax_amount: roundOffPrice(inclusive_vat) }],
          card_number: "",
          order_payment_bank: null,
        }));
        setPaidMoney(parseFloat(roundOffPrice(new_amount)))
        //setPaidMoney(parseFloat(new_amount.toFixed(2)));
        setReturnMoneyUsd(0);

      } else {
        let theUsdPaid = paidMoney / localCurrency.rate;

        if (checkOrderDetails && checkOrderDetails.item !== null) {
          let total = totalAmount;
          setTaxPercent(checkOrderDetails.item.theBranch.branch_tax);
          const calLoyaltyPoint = handleCalLoyaltyPoints(total);
          if (calLoyaltyPoint > 0) {
            total -= calLoyaltyPoint
          }

          if (
            roundOffPrice(theUsdPaid) <
            (roundOffPrice(total) - roundOffPrice(checkOrderDetails.item.paid_amount))
          ) {
            setReturnMoneyUsd(0);
            toast.error(
              `${_t(
                t(
                  "Please enter paid amount atleast equal to the total bill amount"
                )
              )}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );

          } else {
            let theReturnMoney = roundOffPrice(theUsdPaid) -
              roundOffPrice(total) - roundOffPrice(checkOrderDetails.item.paid_amount);
            setReturnMoneyUsd(roundOffPrice(theReturnMoney));
          }
          setCheckOrderDetails((curr) => ({
            ...curr,
            item: {
              ...curr.item,
              vat: roundOffPrice(taxAmount),
              total_payable: roundOffPrice(total),
            },
            payment_type: [{ ...payment_type, bill_amount: roundOffPrice(total), tax_percent: curr.item.theBranch.branch_tax, tax_amount: roundOffPrice(taxAmount) }],
            card_number: "",
            order_payment_bank: null,
          }));
        }
      }
    }
  };

  const paymentTypePrint = (payment_type) => {
    let b_tax = checkOrderDetails.item?.payment_tax[payment_type.name];
    let inclusive_vat = 0;
    let previous_amount = 0;
    let new_amount = 0;
    if (!checkOrderDetails.item?.is_advance_booking && b_tax && b_tax >= 0) {
      let vatCalculate = getSystemSettings(generalSettings, "tax_type_discount") === "tax_discount_after" ? (parseFloat(checkOrderDetails.item.order_bill) - parseFloat(checkOrderDetails.item.discount_amount)) : parseFloat(checkOrderDetails.item.order_bill);
      inclusive_vat = vatCalculate * (parseFloat(b_tax) / 100);
      previous_amount = parseFloat(checkOrderDetails.item.total_payable) - parseFloat(checkOrderDetails.item.vat);
      new_amount = previous_amount + inclusive_vat;
      setTaxPercent(b_tax);
      setCheckOrderDetails((curr) => ({
        ...curr,
        item: {
          ...curr.item,
          total_payable: roundOffPrice(new_amount),
          vat: roundOffPrice(inclusive_vat),
        },
        payment_type: [{ ...payment_type, bill_amount: roundOffPrice(new_amount), tax_percent: b_tax, tax_amount: roundOffPrice(inclusive_vat) }],
        card_number: "",
        order_payment_bank: null,
      }));

    } else {
      if (checkOrderDetails && checkOrderDetails.item !== null) {
        let total = checkOrderDetails.item.total_payable;
        setTaxPercent(checkOrderDetails.item.theBranch.branch_tax);
        setCheckOrderDetails((curr) => ({
          ...curr,
          item: {
            ...curr.item,
            total_payable: roundOffPrice(total),
          },
          card_number: "",
          order_payment_bank: null,
        }));
      }
    }
  }

  //payment type amount
  const handlePaymentTypeAmount = (e) => {
    let tempPaymentAmount = {
      ...checkOrderDetails.payment_amount,
      [e.target.name]: e.target.value,
    };

    setCheckOrderDetails({
      ...checkOrderDetails,
      payment_amount: tempPaymentAmount,
    });

    //calculate paid amount to set return amount
    handleCalculatePaid(tempPaymentAmount, checkOrderDetails.payment_type);
  };

  //calculate paid amount
  const handleCalculatePaid = (paymentAmount, paymentType) => {
    let paidAmount = 0;
    if (paymentAmount !== null && paymentType !== null) {
      let thePaymentArray = [];
      if (paymentAmount) {
        thePaymentArray = Object.entries(paymentAmount);
      }
      thePaymentArray.map((eachPaymentItem) => {
        let thePaymentType = paymentType.find((paymentTypeItem) => {
          return paymentTypeItem.id === parseInt(eachPaymentItem[0]);
        });
        if (eachPaymentItem[1] !== "") {
          if (
            thePaymentType &&
            thePaymentType.id === parseInt(eachPaymentItem[0])
          ) {
            paidAmount = paidAmount + parseFloat(eachPaymentItem[1]);
          }
        }
      });
      let localCurrency = JSON.parse(localStorage.getItem("currency"));
      paidAmount = paidAmount / localCurrency.rate;
      let theReturnMoney = 0;
      if (checkOrderDetails.item) {
        theReturnMoney = paidAmount - parseFloat(checkOrderDetails.item.total_payable);
      }
      setReturnMoneyUsd(roundOffPrice(theReturnMoney));
    } else {
      setReturnMoneyUsd(0);
    }
    setPaidMoney(roundOffPrice(paidAmount));
  };

  //empty state  after settle
  const handleSubmitSuccess = () => {
    setCheckOrderDetails({
      ...checkOrderDetails,
      item: null,
      payment_type: null,
      payment_amount: null,
      settle: false,
      card_number: "",
      order_payment_bank: null,
    });
    orderDetailsRef.current = null;
    feedbackRef.current = null;
    fbrNum.current = null;
    srbNum.current = {
      number: "",
      url: "",
    };
    setSrbInvoiceNum({
      number: "",
      url: "",
    });
    setFbrInvoiceNum(null);
    setCardNumber({
      first: "******",
      middle: "****",
      last: ""
    });
    setloyaltyPoint({
      qr_code: "",
      availablePoints: 0,
      earnedPoints: 0,
      redeemPoints: 0,
      phn_no: "",
      verified: true,
      type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "get-info" : "token",
      maxRedeemPoints: "",
      customerName: ""
    })
    isSettle.current = 0;
    setPaidMoney(0);
    setKotPrintIdx(0);
    setSelectedKot({});
    setFoodGroupsToPrint({});
    setPayModal(false);
    setLoading(false);
    setShowSettle(false);
  }
  const getOrderTypeImage = (name) => {
    switch (name?.toLowerCase()) {
      case "dine-in":
        return "/assets/img/chicken-grilled-stream.svg";
      case "delivery":
        return "/assets/img/E Bike Fill Streamline Remix Fill.svg";
      case "takeaway":
        return "/assets/img/Fast Food Streamline Ionic Filled.svg";
      default:
        return "/assets/img/Fast Food Streamline Ionic Filled.svg";
    }
  };

  //print receipt payload
  const formDataReturn = (is_cancel = 0, is_settled = 1) => {
    const itemData = is_settled ? (checkOrderDetails?.item || orderDetailsRef.current?.item)
      : (orderDetailsRef.current?.item || checkOrderDetails.item);

    const returnAmount = (checkOrderDetails?.settle ? paidMoney : itemData.paid_amount) -
      parseFloat(itemData.total_payable) > 0 ?
      roundFormatPrice(
        (checkOrderDetails.settle
          ? paidMoney
          : itemData.paid_amount) -
        parseFloat(
          itemData.total_payable
        )
      )
      : roundFormatPrice(0);
    const workPeriod = workPeriodListForBranch &&
      workPeriodListForBranch.find((tempWorkPeriod) => {
        return (itemData.branch_id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null;
      });

    let formatTime = moment(itemData.created_at).format('DD-MMM-YYYY hh:mm A');
    const ref_no = itemData.party_name +  " - ref no :"  + itemData?.ref_no ? itemData.ref_no : "";

    const checkRequestOrder = itemData && (itemData?.request_from === "POS" ||
      itemData?.request_from === undefined || itemData?.request_from === null);
    const shouldMultiply = multiplyAddon || checkRequestOrder;

    let feedbackUrl = "";
    if(is_settled){
      if(parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1){
        feedbackUrl = window.location.origin + "/feedback/" + feedbackRef.current;
      }else if(itemData.theBranch?.feedback_url){
        feedbackUrl = itemData.theBranch?.feedback_url + "?uid=" + (itemData.id);
      }
    }

    return {
      site_name: getSystemSettings(generalSettings, "siteName"),
      branch: itemData.theBranch,
      type_print_heading: getSystemSettings(
        generalSettings,
        "type_print_heading"
      ),
      payment_type: checkOrderDetails.payment_type,
      serviceCharge: itemData.service_charge,
      service_amount: itemData.service_amount,
      discount: itemData.discount,
      disableAddonMultiplication: !shouldMultiply,
      party_name: itemData.order_type_name + "-" + itemData.party_name,
      subTotal: itemData.order_bill,
      totalPayable: itemData.total_payable,
      theVat: itemData.vat,
      tax_percent: taxPercent > 0 ? taxPercent : itemData.theBranch?.branch_tax,
      print_tax: itemData.theBranch?.print_tax,
      RefNo: ref_no,
      print_footer: getSystemSettings(generalSettings, "type_print_footer"),
      print_bill_footer: getSystemSettings(generalSettings, "print_bill_footer"),
      kot_header: getSystemSettings(generalSettings, "kot_header"),
      user_name: authUserInfo && authUserInfo.details && authUserInfo.details.name,
      tax_type: taxType,
      fixed_tax_type: parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1,
      loyalty_point: loyaltyPoint,
      created_by: itemData?.user_name,
      rider_name: itemData?.delivery_boy_name ? itemData.delivery_boy_name : "",
      rider_notes: itemData?.note_to_rider ? itemData.note_to_rider : "",
      feedback_url: is_settled ? feedbackUrl : "",
      order_tip: itemData?.order_tip,
      //customer print
      customerIp: itemData.theBranch.kitchen_printer_ip != null && JSON.parse(itemData.theBranch.kitchen_printer_ip)?.[authUserInfo.details.id] ? JSON.parse(itemData.theBranch.kitchen_printer_ip)[authUserInfo.details.id] : null,
      deliveryIp: itemData.theBranch.customer_counter_ip != null && itemData.theBranch.customer_counter_ip !== "" ? itemData.theBranch.customer_counter_ip : null,
      customerOrder: itemData.orderedItems,
      ...(!is_settled && { orderItems: !Object.keys(selectedKot).length === 0 ? selectedKot : handleKotItem() }),
      dept_tag: {
        id: itemData?.dept_tag_id,
        name: itemData.dept_tag_name,
      },
      orderTypeDetails: {
        orderTypeId: itemData?.order_type_id,
        orderTypeName: itemData.order_type_name,
      },
      partyDetails: {
        partyId: itemData?.party_id,
        partyName: itemData.party_name,
      },
      is_online: 1,
      guest: itemData.total_guest,
      is_reservation: false,
      isSettle: is_settled,
      is_cancelled: is_cancel,
      table: null,
      vehicle_no: itemData?.vehicle_no ?? "",
      waiter: itemData.waiter_name,
      payment_amount: itemData?.payment_amount ?? null,
      card_number: itemData?.card_number,
      redeem_points: loyaltyPoint.redeemPoints,
      available_points: loyaltyPoint.availablePoints,
      earned_points: loyaltyPoint.earnedPoints,
      newCustomer: 0,
      newCustomerInfo: {
        name: itemData.customer_name,
        email: "",
        address: itemData.delivery_address,
        ref_no: itemData.ref_no,
        phn_no: itemData.delivery_phn_no,
        nearest_landmark: itemData.nearest_landmark,
        alt_phn_no: itemData?.alt_phn_no,
      },
      token: {
        id: itemData.token.id,
        time: formatTime,
        invoice_no: parseInt(getSystemSettings(generalSettings, "order_no")) === 1 ? (itemData?.order_no || "") : "",
        token: itemData.token.id
      },
      total_guest: itemData.total_guest,
      table_id: itemData.table_id,
      table_name: itemData.table_name,
      discount_voucher: "",
      scheme: {
        id: itemData.scheme_id,
        discount: itemData.discount,
        how_much_discount: itemData?.discount_amount,
      },
      paidMoney: paidMoney,
      dept_commission: "",
      workPeriod: workPeriod ? workPeriod : {
        id: itemData.work_period_id,
        token: itemData.token
      },
      order_id: null,
      orderFoodGroups: null,
      selectedPropertyGroup: [],
      return_amount: returnAmount,
      fbr_num: fbrNum.current,
      srb_num: srbNum.current.number,
      srb_qr_url: srbNum.current.url,
    };
  };

  // local server print
  const handleLocalPrint = (is_cancel = 0, is_settled = 0, isCancelPrint = false) => {
    let formData = formDataReturn(is_cancel, is_settled);
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000,
    };
    axios
      .post(getDynamicOfflinePrintUrl("/example-app/api/test"), formData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        handleSubmitSuccess();
      })
      .catch((err) => {
        if(err.response?.data?.message){
          toast.error(err.response?.data?.message, toastObj)
        }
        if (isCancelPrint) {
          handlePrintCondition();
        } else {
          handleOnlyPrint();
        }
      });
  };

  // Validate & settle the current order
  const handleSettleOrder = (e) => {
    e.preventDefault();

    const paymentTypes = checkOrderDetails?.payment_type;
    const orderItem = checkOrderDetails?.item;
    const hasPaymentType = paymentTypes !== null && paymentTypes !== undefined;

    // Single payment: bill amount must equal total payable (auto-correct if mismatched)
    if (
      paymentTypes?.length === 1 &&
      paymentTypes[0]?.bill_amount !== orderItem?.total_payable
    ) {
      toast.error(`${_t(t("Bill amount not match to total"))}`, toastObj);
      setCheckOrderDetails((curr) => ({
        ...curr,
        payment_type: [
          { ...curr.payment_type[0], bill_amount: orderItem.total_payable },
        ],
      }));
      return false;
    }

    // Payment method required
    if (!hasPaymentType) {
      toast.error(`${_t(t("Please select a payment method"))}`, toastObj);
      return false;
    }

    // Customer info required when any selected payment has customer_mandatory
    const requiresCustomer = (Array.isArray(paymentTypes) ? paymentTypes : []).some(
      (pay) => Number(pay?.customer_mandatory) === 1
    );
    const hasCustomerInfo = Boolean(
      (orderItem?.customer_name && String(orderItem.customer_name).trim()) ||
        (orderItem?.delivery_phn_no && String(orderItem.delivery_phn_no).trim())
    );
    if (requiresCustomer && !hasCustomerInfo) {
      toast.error(`${_t(t("Please add customer information"))}`, toastObj);
      setIsCustomerUpdateModal(true);
      return false;
    }

    // Card number required when payment type has view_card enabled
    const requiresCard = paymentTypes[0]?.view_card === 1;
    const cardMissing =
      checkOrderDetails.card_number === null ||
      checkOrderDetails.card_number === "";
    if (requiresCard && cardMissing) {
      toast.error(`${_t(t("Please Enter Card Number"))}`, toastObj);
      cardAdd.current.classList += " showing";
      return false;
    }

    const requiresBank = Number(paymentTypes[0]?.bank_required) === 1;
    if (requiresBank && !checkOrderDetails.order_payment_bank) {
      toast.error(`${_t(t("Please select a bank"))}`, toastObj);
      cardAdd.current.classList += " showing";
      return false;
    }

    // Paid amount must cover remaining due
    const dueAmount = parseFloat(
      orderItem.total_payable - orderItem.paid_amount
    );
    if (paidMoney < dueAmount) {
      toast.error(
        `${_t(t("Please enter paid amount atleast equal to the total due amount"))}`,
        toastObj
      );
      return false;
    }

    setLoading(true);
    handleSettleOrderAxiosReq();
  };

  //settle order api for fresh data
  const handleSubmitToSettle = async (data, type = "") => {
    const item = parseInt(authUserInfo?.details?.offline_enable) === 1 ? (data) : await fetchOrderData(data, setDataPaginating);
    if (item) {
      setReturnMoneyUsd(0);
      setTaxAmount(parseFloat(item.vat));
      if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (item.theBranch.sbr_integration === 1 ||
        item.theBranch.fbr_integration === 1 || item.theBranch?.kpra_integration === 1 || item.theBranch.cbr_integration === 1 || item.theBranch?.pbr_integration === 1)) {
        setTotalAmount(parseFloat(item.total_payable) + 1);
        setCheckOrderDetails({
          ...checkOrderDetails,
          item: {
            ...item,
            total_payable: parseFloat(item.total_payable) + 1
          },
          settle: true,
          payment_amount: null,
          payment_type: null,
        });
      } else {
        setCheckOrderDetails({
          ...checkOrderDetails,
          item: item,
          settle: true,
          payment_amount: null,
          payment_type: null,
        });
        setTotalAmount(parseFloat(item.total_payable));
      }
      if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
        setloyaltyPoint({
          ...loyaltyPoint,
          phn_no: item.delivery_phn_no ?? "",
          ...(!item.delivery_phn_no && { type: "get-info" }),
        })
      }

      setDataPaginating(false);
      if (type === "modal") {
        setPaidMoney(0);
      } else {
        setShowSettle(true);
      }
    }
  }

  let networkStatus = true;
  //settle order server request
  const handleSettleOrderAxiosReq = async () => {
    const endPoint = "/settings/settle-submitted-order";
    const url = getOfflineApiUrl(endPoint)
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    setLoading(true);
    let paymentResponse = await processPaymentIntegrations(
      checkOrderDetails.item.theBranch?.payment_integration,
      checkOrderDetails?.payment_type,
      checkOrderDetails.item.token?.id,
      checkOrderDetails.item.restaurant_id,
      checkOrderDetails.item.theBranch
    );

    let total = checkOrderDetails.item.total_payable;
    let paymentType = (checkOrderDetails?.payment_type || []);
    const integrationRes = paymentResponse?.response || paymentResponse;
    const paymentIntegration = integrationRes
      ? (integrationRes?.success ? integrationRes.data : integrationRes.error)
      : "";

    if (paymentResponse) {
      if ((integrationRes?.response !== "APPROVED" && integrationRes !== "APPROVED") || integrationRes?.error) {
        setLoading(false);
        return false;
      }
      paymentType = paymentType.map((item) => {
        if (
          String(item?.id) === String(paymentResponse?.payment_type_id || integrationRes?.payment_type_id)
        ) {
          return {
            ...item,
            payment_integration: paymentIntegration,
          };
        }
        return item;
      });
    }

    let discount = 0;
    if (integrationRes?.data && Number(integrationRes.data?.DISCOUNTAMOUNT) > 0) {
      discount = (Number(integrationRes.data.DISCOUNTAMOUNT)) - Number(integrationRes.data?.TIPAMOUNT || 0);
      total -= discount;
    }


    let formData = {
      branch_id: checkOrderDetails.item.branch_id,
      order_group_id: checkOrderDetails.item.id,
      payment_type: paymentType,
      payment_amount: checkOrderDetails.payment_amount,
      party_id: checkOrderDetails.item?.party_id,
      is_advance_booking: checkOrderDetails.item.is_advance_booking,
      vat: checkOrderDetails.item.vat,
      order_bill: checkOrderDetails.item.order_bill,
      order_items: checkOrderDetails.item.orderedItems,
      total_payable: total,
      scheme: {
        scheme_name: integrationRes?.data?.CAMPAIGNNAME ?? "",
        discount_amount: discount,
      },
      payment_card_number: checkOrderDetails.card_number,
      order_payment_bank: checkOrderDetails.order_payment_bank?.id ?? null,
      order_tip: checkOrderDetails.item?.order_tip,
      loyalty_type: loyaltyPoint.type,
      loyalty_qr_code: loyaltyPoint.qr_code,
      loyalty_phn_no: loyaltyPoint.phn_no,
      redeem_points: loyaltyPoint.redeemPoints,
      available_points: loyaltyPoint.availablePoints,
      customerInfo: {
        name: checkOrderDetails.item.customer_name,
        email: checkOrderDetails.item.email,
        address: checkOrderDetails.item.delivery_address,
        ref_no: checkOrderDetails.item.ref_no ?? "",
        phn_no: checkOrderDetails.item.delivery_phn_no,
        nearest_landmark: checkOrderDetails.item.nearest_landmark ?? "",
        alt_phn_no: checkOrderDetails.item?.alt_phn_no ?? "",
      },
      status: checkStatus,
      tax_percent:
        taxPercent > 0
          ? taxPercent
          : checkOrderDetails.item.theBranch?.branch_tax,
      paidMoney:
        getSystemSettings(generalSettings, "pos_screen") === "0"
          ? paidMoney
          : paidMoney / localCurrency.rate,
      localCurrency: localCurrency,
      payment_integration: paymentIntegration,
    };
    
    axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
        timeout: 60000,
      })
      .then(async (res) => {
        if (res.data !== "paymentIssue") {
          setSrbInvoiceNum({
            number: res.data[2]?.srb_pos_invoice_no,
            url: res.data[res.data.length - 2],
          });
          setFbrInvoiceNum(res.data[2]?.fbr_pos_invoice_no);
          isSettle.current = res.data[2]?.is_settled ?? 1;
          fbrNum.current = res.data[2]?.fbr_pos_invoice_no
          srbNum.current = {
            number: res.data[2]?.srb_pos_invoice_no,
            url: res.data[res.data.length - 2],
          };
          setloyaltyPoint((curr) => ({
            ...curr,
            earnedPoints: Number(res.data[res.data.length - 1]?.rwrds_earned ?? 0),
          }));
          let hashId = "";
          if (parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1) {
            try {
              hashId = await encryptAES128(checkOrderDetails.item?.id);
            } catch (err) {
              hashId = "";
            }
            feedbackRef.current = hashId;
          }
          setCheckOrderDetails((curr) => ({
            ...curr,
            item: {
              ...curr.item,
              hashId: hashId
            }
          }));
          if (parseInt(checkOrderDetails.item.theBranch?.direct_ip_print) || parseInt(getSystemSettings(generalSettings, "direct_ip_print"))) {
            handleLocalPrint(0, 1);
          } else {
            Promise.resolve().then(() => {
              handleOnlyPrint();
            });
          }
          setSearchedOrder({
            ...searchedOrder,
            searched: false,
          });
          if (sessionStorage.getItem("techloyalty")) {
            sessionStorage.removeItem("techloyalty");
          }
          const isOfflineEnabled = parseInt(authUserInfo.details?.offline_enable) === 1;
          if (isOfflineEnabled && !syncOrder) {
            networkStatus = await checkNetworkStatus();
            if(networkStatus){
              syncLocalOrders()
            }
          }
        } else {
          setLoading(false);
          toast.error(`${_t(t("Please enter paid amount atleast equal to the total due amount"))}`, toastObj);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response?.data && (error.response.data?.status == 1 || error.response?.data?.status === 0)) {
          toast.error(<span style={{ whiteSpace: "pre-line" }}>{error.response.data.message}</span>, {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          if (error.response.data?.status == 1) {
            handleGoBack();
            setPaginatedSubmittedOrders();
          }
          return false;
        }

        toast.error(`${_t(t("Please contact support"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //search submitted orders here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (submittedOrdersForSearch && submittedOrdersForSearch?.length) {
      if (searchInput.length === 0 || searchInput === "all") {
        setSearchedOrder({ list: null, searched: false });
      } else {
        let searchedList = submittedOrdersForSearch && submittedOrdersForSearch?.filter((item) => {
          //token
          let lowerCaseItemToken = item.token?.id && JSON.stringify(item.token?.id)?.toLowerCase();
          let orderNo = item?.order_no && item.order_no.toString();
          //customer
          let lowerCaseItemCustomer = item.customer_name && item.customer_name.toLowerCase();
          let customerPhone = item.delivery_phn_no && item.delivery_phn_no;
          let customerAltPhone = item.alt_phn_no && item.alt_phn_no;
          //table
          let lowerCaseItemTable =
            item.table_name && item.table_name.toLowerCase();
          //branch
          let lowerCaseItemBranch =
            item.branch_name && item.branch_name.toLowerCase();
          //order type
          let lowerCaseItemOrderType =
            item.order_type_name && item.order_type_name.toLowerCase();
          let lowerCaseWaiter = item.waiter_name && item.waiter_name.toLowerCase();
          let totalPayable = item.total_payable && item.total_payable;
          let riderName = item?.delivery_boy_name && item.delivery_boy_name.toLowerCase();
          let partyName = item?.party_name && item.party_name.toLowerCase();

          return (
            (lowerCaseItemToken && lowerCaseItemToken.includes(searchInput)) ||
            (lowerCaseItemCustomer && lowerCaseItemCustomer.includes(searchInput)) ||
            (lowerCaseItemTable && lowerCaseItemTable.includes(searchInput)) ||
            (lowerCaseItemOrderType && lowerCaseItemOrderType.includes(searchInput)) ||
            (lowerCaseItemBranch && lowerCaseItemBranch.includes(searchInput)) ||
            (orderNo && orderNo.includes(searchInput)) ||
            (customerPhone && customerPhone.includes(searchInput)) ||
            (customerAltPhone && customerAltPhone.includes(searchInput)) ||
            (lowerCaseWaiter && lowerCaseWaiter.includes(searchInput)) ||
            (totalPayable && totalPayable.includes(searchInput)) ||
            (riderName && riderName.includes(searchInput)) ||
            (partyName && (searchInput === "carhop" ? partyName === "carhop" : partyName.includes(searchInput)))
          );
        });
        setSearchedOrder({
          ...searchedOrder,
          list: searchedList,
          searched: true,
        });
      }
    }
  };

  //free of cost order confirmation modal
  const handleFreeCostOrderConfirmation = (orderGroup) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        const FreeCostModal = () => {
          const [isSubmitting, setIsSubmitting] = useState(false);

          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">
                {_t(t("You want free of cost this order?"))}
              </p>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleFreeCostItem(e, orderGroup, onClose, setIsSubmitting);
                }}
                autoComplete="off"
              >
                {passcodeApplied ? (
                  <div className="form-group mb-4">
                    <label
                      htmlFor="passcode"
                      className="font-weight-bold mr-4 lg-text"
                    >
                      Enter passcode
                    </label>
                    <input
                      type="text"
                      className="form-control secure-password-field w-50 d-inline-block"
                      name="passcode"
                      id="passcode"
                      placeholder="Password"
                      required
                    />
                  </div>
                ) : null}
                <div className="form-group mb-4">
                  <label
                    htmlFor="passcode"
                    className="mb-2 lg-text"
                  >
                    Enter Reason
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="reason"
                    id="reason"
                    placeholder="reason"
                    required
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <button
                    disabled={isSubmitting}
                    className="btn btn-primary"
                    type="submit"
                  >
                    {_t(t("Yes, free of cost!"))}
                  </button>
                  <button type="button" className="btn btn-success ml-2 px-3" onClick={onClose} disabled={isSubmitting}>
                    {_t(t("No"))}
                  </button>
                </div>
              </form>
            </div>
          );
        };
        return <FreeCostModal />;
      },
    });
  };


  const handleFreeCostItem = (e, orderGroup, onClose, setIsSubmitting = null) => {
    const endPoint = "/settings/foc-submitted-order";
    const url = getOfflineApiUrl(endPoint);
    let formData = {
      id: orderGroup.id,
      user_id: authUserInfo.details.id,
      user_name: authUserInfo.details.name,
      refund_reason: e.target["reason"].value,
      // item: orderGroup.orderedItems,
      manager_id: orderGroup?.manager_id || null,
    };
    if (passcodeApplied) {
      const enteredPasscode = e.target["passcode"].value;
      if (authUserInfo.details.user_passcode ? (enteredPasscode !== authUserInfo.details.user_passcode) : !managerPasscode.hasOwnProperty(enteredPasscode)) {
        toast.error("Incorrect password! Try again.", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
    }
    if (authUserInfo.details.user_passcode || managerPasscode) {
      if (e.target["passcode"]) {
        e.target["passcode"].value = "";
      }
    }
    if (e.target["reason"].value === "" || e.target["reason"].value === null) {
      toast.error(`${_t(t("Please add reason"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } else {
      if (setIsSubmitting) setIsSubmitting(true);
      setLoading(true);
      axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          onSearchClear();
        })
        .catch(() => {
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }).finally(() => {
          if (setIsSubmitting) setIsSubmitting(false);
          onClose()
          setLoading(false);
          // setPaginatedSubmittedOrders(1);
        });
    }
  }
  //cancel item pop up empty  
  const handleCancelEmpty = () => {
    setItemToDelete(null);
    setDeleteReasonModalShowing(false);
  }

  //cancel order confirmation modal
  const handleCancelOrderConfirmation = (orderGroup) => {
    setItemToDelete(null);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">
              {_t(t("You want to cancel this order?"))}
            </p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={async () => {
                  onClose();
                  const item = parseInt(authUserInfo?.details?.offline_enable) === 1 ? (orderGroup) : await fetchOrderData(orderGroup, setDataPaginating);
                  if (item) {
                    let previousTime = false
                    if (authUserInfo.details.user_type !== "admin" && authUserInfo.details.user_type !== "superAdmin" &&
                      item.theBranch?.cancel_order && item.theBranch.cancel_order_time) {
                      previousTime = new Date(item.created_at);
                      previousTime.setMinutes(previousTime.getMinutes() + Number(item.theBranch.cancel_order_time));
                    }
                    const currentTime = new Date();
                    setItemToDelete({
                      ...item,
                      madeButton: previousTime ? (Boolean(currentTime > previousTime)) : false,
                    });
                    setDeleteReasonModalShowing(true);
                  }
                  // handleCancelOrder(orderGroup);
                }}
              >
                {_t(t("Yes, cancel it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //waiter chnage api
  const handleWaiterChangeApi = (e) => {
    e.preventDefault();
    const endPoint = "/settings/assign-waiter";
    let url = getOfflineApiUrl(endPoint);
    let formData = {
      order_id: changeWaiter?.id,
      waiter: changeWaiter.waiterSelected,
    };
    if (changeWaiter.waiterSelected) {
      setLoading(true);
      axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setRiderModal(false);
          setSearchedOrder({
            ...searchedOrder,
            searched: false,
          });
          setCheckOrderDetails({
            item: null,
            payment_amount: null,
            payment_type: null,
            settle: false,
            uploading: false,
            card_number: "",
            order_payment_bank: null,
          })
          setChangeWaiter({
            waiterSelected: null,
            id: null,
            modal: false,
            searchWaiter: null,
            waiters: null,
          })
          setLoading(false);
          toast.success(`${_t(t("Waiter has been assigned sucessfully"))}`, {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });

        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    }
  }

  //split bill
  const handleSplitBill = (item) => {
    const { orderedItems, ...rest } = JSON.parse(JSON.stringify(item));
    const orderItems = {}
    orderedItems.forEach((item) => {
      orderItems[item.id] = item
    })
    setBillModal({
      modal: true,
      currentState: 0,
      orderDetail: rest,
      originalItem: orderItems,
      currentItem: orderItems,
    });
  }

  // assign rider api 
  const handleRider = (e) => {
    e.preventDefault();
    const endPoint = "/settings/assign-rider";
    let url = getOfflineApiUrl(endPoint);
    let formData = {
      order_id: checkOrderDetails.item?.id,
      delivery_man_id: checkOrderDetails?.delivery_man_id?.id,
      delivery_man_name: checkOrderDetails?.delivery_man_id?.name,
      time_to_deliver: checkOrderDetails?.time_to_deliver,
      delivery_status: deliveryStatus.id,
      delivery_status_name: deliveryStatus.name,
    };
    if (checkOrderDetails?.delivery_man_id?.id) {
      setLoading(true);
      axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          if (res) {
            setRiderModal(false);
            setSearchedOrder({
              ...searchedOrder,
              searched: false,
            });
            setCheckOrderDetails({
              item: null,
              payment_amount: null,
              payment_type: null,
              settle: false,
              uploading: false,
              card_number: "",
              order_payment_bank: null,
            })
            if (res.data !== "added" && parseInt(authUserInfo?.details?.offline_enable) !== 1) {
              window.open(res.data, '_blank');
            }
            setLoading(false);
            toast.success(`${_t(t("Rider has been assigned sucessfully"))}`, {
              position: "bottom-center",
              closeButton: false,
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    }
  }

  const handleItemChange = (e, items) => {
    if (e.target.value === "unmade") {
      items && items.orderedItems.forEach((item) => {
        const element = document.getElementById(`item-${item.id}-made-0`);
        if (element) {
          element.click();
        }
      });
    } else {
      items && items.orderedItems.forEach((item) => {
        const element = document.getElementById(`item-${item.id}-made-1`);
        if (element) {
          element.click();
        }
      });
    }
  }

  // cancel order reason
  const handleCancelOrderReasonSubmit = (e, item) => {
    if (passcodeApplied) {
      const enteredPasscode = e.target["passcode"].value;
      if (authUserInfo.details.user_passcode ? (enteredPasscode !== authUserInfo.details.user_passcode) : !managerPasscode.hasOwnProperty(enteredPasscode)) {
        toast.error("Incorrect password! Try again.", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
    }
    const reason = e.target["deleteReason"].value;
    const items = item.orderedItems.map((item) => ({
      ...item,
      reason: reason,
      status: e.target[`item-${item.id}-made`].value,
    }));
    setDeleteReasonModalShowing(false);
    handleCancelOrder(item, items, e);
    e.target["deleteReason"].value = "";
    if (authUserInfo.details.user_passcode) {
      if (e.target["passcode"]) {
        e.target["passcode"].value = "";
      }
    }
  };

  //cancel order here
  const handleCancelOrder = (orderGroup, items) => {
    const endPoint = "/settings/cancel-submitted-order";
    const url = getOfflineApiUrl(endPoint);

    let formData = {
      id: orderGroup.id,
      items: items,
      manager_id: orderGroup?.manager_id || null,
    };
    setLoading(true);
    handleKotItem(items);
    axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLoading(false);
        if (res) {
          const item = { ...checkOrderDetails.item };
          item.is_cancelled = 1;
          item.orderedItems = items;
          orderDetailsRef.current = { item: item };
          setCheckOrderDetails((curr) => ({
            ...curr,
            item: item,
          }));

          onSearchClear();
          Promise.resolve().then(() => {
            if (parseInt(checkOrderDetails.item.theBranch?.direct_ip_print) || parseInt(getSystemSettings(generalSettings, "direct_ip_print"))) {
              handleLocalPrint(1, 0, true);
            } else {
              handlePrintCondition()
            }
          });
        }
      })
      .catch(() => {
        setKotPrintIdx(0);
        setSelectedKot({});
        setFoodGroupsToPrint({});
        orderDetailsRef.current = null
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
    // } else {
    //   toast.error(
    //     `${_t(t("Can not cancel this order, this is being cooked"))}`,
    //     {
    //       position: "bottom-center",
    //       closeButton: false,
    //       autoClose: 10000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       className: "text-center toast-notification",
    //     }
    //   );
    // }
  };

  const handleCarhopReady = (e, item) => {
    e.stopPropagation();
    const url = BASE_URL + "/settings/change-carhop-order-status";
    
    let formData = {
      order_id: item.id,
      token_no: item.token?.id ?? "",
      branch_id: item.branch_id,
      user_id: item.user_id,
      status: "READY",
    };

    setLoading(true);
    axios.post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => {
      setLoading(false);
      const updatedMap = { ...orderFlowStatus, [item.id]: "READY" };
      setOrderFlowStatus(updatedMap);
      try {
        const saved = JSON.parse(localStorage.getItem("pos_order_flow_status") || "{}");
        saved[item.id] = "READY";
        localStorage.setItem("pos_order_flow_status", JSON.stringify(saved));
        localStorage.setItem("pos_order_ready", JSON.stringify({ id: item.id, token: item.token?.id || "", time: Date.now() }));
        localStorage.setItem("orderscreen_last_update", Date.now().toString());
      } catch (e) {}
      const branchId = item.branch_id || authUserInfo?.details?.branch_id;
      if (branchId && generalSettings) {
        const collection = getSystemSettings(generalSettings, "firebase_collection");
        if (collection) {
          firebaseAuthSetData(`pos/${collection}/order_tracker_screen/${branchId}`, {
            updated_at: Date.now(),
            order_id: item.id,
            status: "READY",
          });
        }
      }
      setPaginatedSubmittedOrders(1);
      toast.success(`${_t(t("Status has been changed." ))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    })
    .catch((err) => {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    });
  };

  // Order status flow handler (Ready -> Dispatch)
  const handleOrderStatusUpdate = (e, item, actionType) => {
    e.stopPropagation();
    const type = actionType.toLowerCase();
    const nextStatus = type === "ready" ? "READY" : "DISPATCHED";

    // Optimistic UI update
    setOrderFlowStatus((prev) => ({ ...prev, [item.id]: nextStatus }));

    const branchId =
      item.branch_id ||
      item.theBranch?.id ||
      authUserInfo?.details?.branch_id ||
      localStorage.getItem("pos_selected_branch_id");

    // 1. Instant local storage broadcast (for tabs on same device)
    try {
      const saved = JSON.parse(localStorage.getItem("pos_order_flow_status") || "{}");
      saved[item.id] = nextStatus;
      localStorage.setItem("pos_order_flow_status", JSON.stringify(saved));
      if (nextStatus === "DISPATCHED") {
        const tokenVal = item.token?.id || (typeof item.token === "string" ? item.token : "") || item.token_no || "";
        localStorage.setItem("pos_order_dispatched", JSON.stringify({ id: item.id, token: tokenVal, time: Date.now() }));
      }
      if (nextStatus === "READY") {
        const tokenVal = item.token?.id || (typeof item.token === "string" ? item.token : "") || item.token_no || "";
        localStorage.setItem("pos_order_ready", JSON.stringify({ id: item.id, token: tokenVal, time: Date.now() }));
      }
      localStorage.setItem("orderscreen_last_update", Date.now().toString());
    } catch (e) {}

    // 2. Cloud Firebase broadcast (for Order Status Screen TV & cross-device)
    if (branchId && generalSettings && firebaseAuthSetData) {
      const collection = getSystemSettings(generalSettings, "firebase_collection");
      if (collection) {
        const tokenVal = item.token?.id || (typeof item.token === "string" ? item.token : "") || item.token_no || "";
        const payload = {
          order: nextStatus,
          status: nextStatus,
          order_id: item.id,
          orderId: item.id,
          token: tokenVal ? String(tokenVal) : "",
          updated_at: Date.now(),
        };
        firebaseAuthSetData(`pos/${collection}/order_tracker_screen/${branchId}`, payload);
        firebaseAuthSetData(`pos/${collection}/order_tracker_screen/${branchId}/${item.id}`, payload);
      }
    }

    const url = `${BASE_URL}/settings/status-change-readydispatch/${item.id}/${type}`;
  
    axios
      .get(url, { headers: { Authorization: `Bearer ${getCookie()}` } })
      .then(() => {
        setPaginatedSubmittedOrders(1);
      })
      .catch(() => {
        // Fallback to 'proceed' endpoint if backend route expects proceed
        axios
          .get(`${BASE_URL}/settings/status-change-readydispatch/${item.id}/proceed`, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then(() => {
            setPaginatedSubmittedOrders(1);
          })
          .catch((err) => {
            console.error("Status update error:", err);
          });
      });
  };

  const getOrderStatus = (item) => {
    if (!item) return "PREPARING";

    if (orderFlowStatus && orderFlowStatus[item.id]) {
      return orderFlowStatus[item.id];
    }

    const backendStatus = (
      item.order_status ||
      item["order-status"] ||
      item["order_status"] ||
      item.kitchen_order_status ||
      item.kitchen_status ||
      ""
    ).toString().trim().toUpperCase();

    if (
      backendStatus === "DISPATCHED" ||
      backendStatus === "DISPATCH" ||
      parseInt(item.is_dispatched) === 1
    ) {
      return "DISPATCHED";
    }
    if (
      backendStatus === "READY" ||
      parseInt(item.is_ready) === 1 ||
      backendStatus === "KR" ||
      backendStatus.includes("READY")
    ) {
      return "READY";
    }

    return "PREPARING";
  };

  const renderOrderStatusBtn = (item) => {
    const status = getOrderStatus(item);

    if (status === "PREPARING") {
      return (
        <button
          type="button"
          className="btn btn-sm ml-2 rounded-sm btn-light-warning font-weight-bold"
          title="Click to mark Ready"
          onClick={(e) => handleOrderStatusUpdate(e, item, "ready")}
        >
          {_t(t("Preparing"))}
        </button>
      );
    }
    if (status === "READY") {
      return (
        <button
          type="button"
          className="btn btn-sm ml-2 rounded-sm btn-light-success font-weight-bold"
          title="Click to Dispatch"
          onClick={(e) => handleOrderStatusUpdate(e, item, "dispatch")}
        >
          {_t(t("Ready"))}
        </button>
      );
    }
    return null;
  };

  const handlePaymentBillPrint = ()=>{
    orderDetailsRef.current = { item: checkOrderDetails.item };
    setTimeout(() => {
      handleOnlyPrint();
    }, 500);
  }

  //print recipt
  const handlePrint = async (e, item, payment=null) => {
    e.stopPropagation();
    const itemData = parseInt(authUserInfo?.details?.offline_enable) === 1 ? (item) : await fetchOrderData(item, setDataPaginating);
    if (itemData) {
      setCheckOrderDetails({
        ...checkOrderDetails,
        item: itemData,
        settle: false,
      });
      handleKotItem(itemData.orderedItems)
      setTaxPercent(0);
      if(payment){
        Promise.resolve().then(() => {
          paymentTypePrint(payment);
          handlePaymentBillPrint();
        });
      }else{
        orderDetailsRef.current = { item: itemData };
        setTimeout(() => {
          handleOnlyPrint();
          // handlePrintAll()
        }, 600);
      }
    }
  }

  //print recipt
  const handleKotPrint = async (e, item, reFetch = false, isProceed =false) => {
    e.stopPropagation();
    const itemData = parseInt(authUserInfo?.details?.offline_enable) === 1 ? (item) : (await fetchOrderData(item, setDataPaginating, isProceed));
    if (itemData) {
      orderDetailsRef.current = { item: itemData };
      handleKotItem(itemData.orderedItems)
      setTaxPercent(0)
      setCheckOrderDetails({
        ...checkOrderDetails,
        item: itemData,
        settle: false,
      });
      if(reFetch){
        setPaginatedSubmittedOrders(1)
      }
      setTimeout(() => {
        if (parseInt(itemData.theBranch?.direct_ip_print) || parseInt(getSystemSettings(generalSettings, "direct_ip_print"))) {
          handleLocalPrint(0, 0, true);
        }else{
          if (getSystemSettings(generalSettings, "print_kitchen_bill") === "1") {
            let kots = getCurrentSelectedKots.current;
            if (kots && Object.keys(kots)?.length) {
              setNextKotPrint();
            } else {
              handleSubmitSuccess();
            }
          } else {
            handleSubmitSuccess();
          }
        }
      }, 800);
    }
  }

  //proceed order confirmation modal
  const handleProceedOrderConfirmation = (e, item) => {
    e.stopPropagation();

    confirmAlert({
      customUI: ({ onClose }) => {
        const ProceedModal = () => {
          const [isSubmitting, setIsSubmitting] = useState(false);

          return (
            <div className="card card-body">
              <h2>{_t(t("Are you sure?"))}</h2>
              <p className="text-center">
                {_t(t("Are you sure to proceed this order?"))}
              </p>
              <div className="d-flex justify-content-center">
                <button
                  disabled={dataPaginating || isSubmitting}
                  className="btn btn-primary mr-2"
                  onClick={() => {
                    setIsSubmitting(true);
                    onClose();
                    handleKotPrint(e, item, true, true);
                    setIsSubmitting(false);
                  }}
                >
                  {_t(t("Yes"))}
                </button>
                <button className="btn btn-success px-3" onClick={onClose} disabled={isSubmitting}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        };
        return <ProceedModal />;
      },
    });
  };

  // Update device token button for selforder
  const renderDeviceTokenButton = (item) => {
    if (item?.order_status === "selforder") {
      return (
        <button
          type="button"
          title="Update Token"
          className="btn btn-secondary btn-sm ml-2 rounded-sm"
          onClick={(e) => {
            e.stopPropagation();
            setDeviceTokenModalItem(item);
          }}
        >
          <MdVpnKey size={18} />
        </button>
      );
    }
    return null;
  };

  //settle row and print btn
  const itemListRowStatus = (item, index) => {
    if(!item) return
    const isCancelled = parseInt(item.is_cancelled) === 1
    const isHold = parseInt(item.is_hold) === 1;

    if (item.order_source?.toLowerCase() === "carhop") {
      return (
        <>
          {isCancelled ? (
            <span
              className="btn btn-transparent btn-light-danger xsm-text text-capitalize px-2"
              onClick={(e) => {
                e.stopPropagation();
                setCheckOrderDetails({
                  ...checkOrderDetails,
                  item: item,
                  settle: false,
                });
                setReturnMoneyUsd(0);
                setPaidMoney(0);
              }}
              data-toggle="modal"
              data-target="#orderDetails"
            >
              {_t(t("Cancelled"))}
            </span>
          ) : (
            <>
              <span
                className="btn btn-transparent btn-secondary xsm-text text-capitalize px-2"
                onClick={(e) => {
                  e.stopPropagation();
                  setCheckOrderDetails({
                    ...checkOrderDetails,
                    item: item,
                    settle: false,
                  });
                  setReturnMoneyUsd(0);
                  setPaidMoney(0);
                }}
                data-toggle="modal"
                data-target="#orderDetails"
                style={{ color: "#3170BF", fontSize: ".75rem" }}
              >
                {
                  isHold ?
                    <>
                      {_t(t("hold"))}
                    </>
                    :
                    <>
                      {_t(t("view"))}
                    </>
                }
              </span>
              <button
                title="procced"
                disabled={dataPaginating}
                // send state- order group id
                className="rounded-sm btn btn-primary btn-sm ml-2"
                onClick={(e) => handleProceedOrderConfirmation(e, item)}
              >
                Proceed
              </button>
              {/* {renderDeviceTokenButton(item)} */}
            </>
          )}
        </>
      )
    }

    return (
      <>
        {!isCancelled ? (
          <span
            className={`btn btn-transparent xsm-text text-capitalize ${
              getOrderStatus(item) === "DISPATCHED"
                ? "btn-primary px-2"
                : getOrderStatus(item) === "READY"
                ? "btn-success px-3"
                : "btn-secondary px-2"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setCheckOrderDetails({
                ...checkOrderDetails,
                item: item,
                settle: false,
              });
              setReturnMoneyUsd(0);
              setPaidMoney(0);
            }}
            data-toggle="modal"
            data-target="#orderDetails"
            style={getOrderStatus(item) === "PREPARING" ? { color: "#3170BF", fontSize: ".75rem" } : undefined}
          >
            {isHold
              ? _t(t("hold"))
              : getOrderStatus(item) === "DISPATCHED"
              ? _t(t("Dispatched"))
              : getOrderStatus(item) === "READY"
              ? _t(t("Ready"))
              : _t(t("processing"))}
          </span>
        ) : (
          <>
            <span
              className="btn btn-transparent btn-light-danger xsm-text text-capitalize px-2"
              onClick={(e) => {
                e.stopPropagation();
                setCheckOrderDetails({
                  ...checkOrderDetails,
                  item: item,
                  settle: false,
                });
                setReturnMoneyUsd(0);
                setPaidMoney(0);
              }}
              data-toggle="modal"
              data-target="#orderDetails"
            >
              {_t(t("Cancelled"))}
            </span>
            {authUserInfo.permissions !== null &&
              checkPermission(authUserInfo.permissions, "Submit Order Print") ?
              <button
                className="btn btn-secondary btn-sm ml-2 rounded-sm"
                onClick={(e) => {
                  handlePrint(e, item);
                }}
              >
                <i className="fa fa-print"></i>
              </button> : null}
          </>
        )}

        {!isCancelled && !isHold ? (
          <>
            {renderOrderStatusBtn(item)}
            {
              (item?.party_name?.toLowerCase() === "carhop") && getOrderStatus(item) !== "READY" && (
                <button
                  className="btn btn-success btn-sm ml-2 rounded-sm"
                  title="Ready"
                  onClick={(e) => handleCarhopReady(e, item)}
                >
                  <i className="fa fa-check"></i>
                </button>
              )
            }
            {getSystemSettings(
              generalSettings, "pos_screen"
            ) === "0" && authUserInfo.permissions !== null &&
              checkPermission(
                authUserInfo.permissions, "List Settle") && parseInt(item?.is_settled) === 2 ? (
              <button
                title="Settle Order"
                disabled={dataPaginating}
                // send state- order group id
                className="rounded-sm btn btn-primary btn-sm ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSubmitToSettle(item, "modal")
                }}
                data-toggle="modal"
                data-target="#orderDetails"
              >
                Settle
              </button>
            ) : (
              authUserInfo.permissions !== null &&
                checkPermission(
                  authUserInfo.permissions, "List Settle"
                ) && parseInt(item?.is_settled) === 2 ? (
                <button
                  title="Settle Order"
                  disabled={dataPaginating}
                  // send state- order group id
                  className="rounded-sm btn btn-success btn-sm ml-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubmitToSettle(item)
                  }}
                >
                  Settle
                </button>
              ) : (
                <></>
              )
            )}
            {authUserInfo.permissions !== null && !isCancelled && !isHold &&
              checkPermission(authUserInfo.permissions, "Submit Order Print") ?
              <button
                className="btn btn-secondary btn-sm ml-2 rounded-sm"
                onClick={(e) => {
                  if (parseInt(getSystemSettings(generalSettings, "duplicate_payment_bill")) === 1) {
                    setPrintPaymentModalItem(item);
                  } else {
                    handlePrint(e, item);
                  }
                }}
              >
                <i className="fa fa-print"></i>
              </button> : null}
              {authUserInfo.permissions !== null &&
                parseInt(getSystemSettings(generalSettings, "duplicate_kot")) === 1 ?
                <button
                  title="kot print"
                  disabled={dataPaginating}
                  className="btn btn-secondary btn-sm ml-2 rounded-sm"
                  onClick={(e) => {
                    handleKotPrint(e, item);
                  }}
                >
                  <BiDish />
                </button> : ""}
              {item.theBranch?.dc_edit && item?.order_type_name?.match(/delivery/i) ? (
                <button
                  title="Delivery Charge Update"
                  className="btn btn-secondary btn-sm ml-2 rounded-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeliveryChargeModalItem(item);
                  }}
                >
                  <MdDeliveryDining size={20} />
                </button>
              ) : ""}
              {/* {renderDeviceTokenButton(item)} */}
          </>
        ) : (
          ""
        )}
      </>
    )
  }

  //select item row
  const selectItemRow = (item) => {
    if (
      checkOrderDetails.item
        ?.id === item?.id
    ) {
      setCheckOrderDetails({
        ...checkOrderDetails,
        item: null,
        settle: false,
      });
    } else {
      setCheckOrderDetails({
        ...checkOrderDetails,
        item: item,
        settle: false,
      });
    }
  }

  const odrItem = checkOrderDetails?.item;
  const isPosOrder = odrItem?.request_from === "POS";
  const editccOdr = parseInt(odrItem?.party_for_cc) === 1 && parseInt(odrItem?.online_order_edit) === 0;

  const onlineOdrEdit = (odrItem && onlineOrderEdit) ? (editccOdr && !isPosOrder)
    : (parseInt(odrItem?.party_for_cc) === 1 || odrItem?.online_order_id);
  
  const editOrderPermission = authUserInfo?.permissions && checkPermission(authUserInfo.permissions, "Order edit");

  //double click order edit
  const doubleClickOrderEdit = (item) => {
    const isPosOrder = item?.request_from === "POS"; 
    const editccOdr = parseInt(item?.party_for_cc) === 1 && parseInt(item?.online_order_edit) === 0;
    if (editOrderPermission) {
      const orderEdit = onlineOrderEdit ? (editccOdr && !isPosOrder) :
                        (parseInt(item?.party_for_cc) === 1 || item?.online_order_id);

      if (item.order_source?.toLowerCase() === "carhop") {
        toast.error("You can't edit without proceed.");
        return
      }

      if((orderEdit) || parseInt(item?.is_advance_booking) === 1) {
        toast.error(`You can't edit ${parseInt(item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
        return
      }
      if (item && parseInt(item.is_cancelled) === 0) {
        history.push(`/dashboard/epos/${item?.id}`, { fromUrl: true });
      } else {
        toast.error("Can't edit cancelled order");
      }
    } else {
      toast.error("You can't edit order check permission");
    }
  }

  let g_total = 0;
  let g_gross = 0;
  let g_after_dis = 0;
  let g_tax = 0;
  let g_delivery = 0;
  let g_discount = 0;
  let g_cancel = 0;

  const toggleSelectAll = (e) => {
    e.stopPropagation();
    let updated = { ...multiSettleOrder.orders };
    let currentAmount = Number(multiSettleOrder.amount) || 0;
    if (e.target.checked) {
      ((searchedOrder?.searched && searchedOrder?.list) || submittedOrders.data).forEach((item) => {
        if (!parseInt(item.is_cancelled) && !parseInt(item.is_hold) && parseInt(item?.is_settled) === 2 && item?.order_source?.toLowerCase() !== "carhop") {
          if (!updated[item.id]) {
            updated[item.id] = item.id;
            currentAmount += Number(item.total_payable || 0);
          }
        }
      })
    } else {
      ((searchedOrder?.searched && searchedOrder?.list) || submittedOrders.data).forEach((item) => {
        if (updated[item.id]) {
          delete updated[item.id];
          currentAmount -= Number(item.total_payable || 0);
        }
      })
    }

    setMultiSettleOrder((curr) => ({
      ...curr,
      orders: updated,
      amount: currentAmount
    }));
  }

  const toggleSelect = (item) => {
    let updated = { ...multiSettleOrder.orders };
    let currentAmount = Number(multiSettleOrder.amount) || 0;
    if (updated[item.id]) {
      delete updated[item.id];
      currentAmount -= Number(item.total_payable || 0);
    } else {
      updated[item.id] = item.id;
      currentAmount += Number(item.total_payable || 0);
    }
    setMultiSettleOrder((curr) => ({
      ...curr,
      orders: updated,
      amount: currentAmount
    }));
  };

  let typeCounts = {};

  const itemListContent = (item, index) => {
    const requestType = getRequestType(item);
    const isChecked = filterTypes[requestType];
    const rowBgColor = isChecked ? getBackgroundColor(requestType) : "";
    const indicatorColor = isChecked ? getCheckboxColor(requestType) : "";
    typeCounts[requestType] = (typeCounts[requestType] || 0) + 1;
    const isDelivery = item.order_type_name?.toLowerCase() ==="delivery";
    const highlightRiderAssignment = isDelivery && !item?.delivery_boy_id ? "bg-warning text-white" : "text-secondary"
    
    const table = JSON.parse(sessionStorage.getItem("itemCounts")) || {};
    let tableColor = ""
    if (table[item.id] && table[item.id] > 3) {
      tableColor = "bg-red text-white";
    } else if (table[item.id] && table[item.id] > 1) {
      tableColor = "bg-warning text-white"
    } else if (table[item.id] && table[item.id] === 1) {
      tableColor = "bg-primary text-white"
    }
    if (parseInt(item.is_cancelled)) {
      g_cancel += Number(item.total_payable);
    } else {
      g_total += Number(item.total_payable);
      g_gross += Number(item.order_bill);
      g_discount += Number(item.discount_amount);
      g_after_dis += (Number(item.order_bill) - Number(item.discount_amount));
      g_delivery += Number(item.service_charge);
      g_tax += Number(item.vat)
    }

    return (
      <>
        <tr
          className={`align-middle cursor-pointer ${checkOrderDetails.item
            ?.id === item?.id
            ? "submitActiveOrder"
            : ""
          }`}
          style={{ backgroundColor: rowBgColor, transition: 'background-color 0.3s' }}
          key={item?.id + item?.order_source}
          onDoubleClick={() => doubleClickOrderEdit(item)}
          onClick={() => selectItemRow(item)}
        >
          <th
            scope="row"
            className="table-text text-capitalize align-middle text-center"
          >
            <div className="d-flex align-items-center justify-content-center">
              {
                indicatorColor && (
                  <div style={{width: 10, height: 10, backgroundColor: indicatorColor, marginRight: 3, borderRadius: 2}}></div>
                )
              }
              <span>
              {index +
                1 +
                (submittedOrders.current_page - 1) *
                submittedOrders.per_page}
              </span>
            </div>
          </th>

          {multiOrderSettle ? (
            <td className="table-text text-capitalize align-middle text-center table_report_col">
              <label key={item.id} className="mr-1" onDoubleClick={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
                <input
                  disabled={parseInt(item.is_cancelled) || parseInt(item.is_hold) || parseInt(item?.is_settled) !== 2 || item?.order_source?.toLowerCase() === "carhop"}
                  id={item.id}
                  type="checkbox"
                  className="form-check-input"
                  checked={multiSettleOrder?.orders && multiSettleOrder.orders[item.id]}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    toggleSelect(item)
                  }}
                />
              </label>
            </td>
          ) : null}

          <td className={`table-text ${highlightRiderAssignment} text-capitalize align-middle text-center table_child_token`}>
            {"#" + item.token?.id}
          </td>

          {isDelivery ? (
            <td className="table-text align-middle text-center bg-primary">
              {item.order_type_name +
                " - " +
                item.party_name}
            </td>
          ) : item.order_type_name ===
            "Takeaway" ? (
            <td className="table-text align-middle text-center bg-secondary">
              {item.order_type_name +
                " - " +
                item.party_name}
            </td>
          ) : (
            <td className="table-text align-middle text-center table_child_ordertype">
              {item.order_type_name +
                " - " +
                item.party_name}
            </td>
          )}
          <td className="table-text align-middle text-center table_child_ordertype">
            {item.customer_name}
          </td>
          <td className="table-text align-middle text-center table_child_branch">
            {item.branch_name || "-"}
          </td>
          {
            authUserInfo.permissions !== null &&
            checkPermission(authUserInfo.permissions, "Submitted Amount") && (
              <td className="table-text text-capitalize align-middle text-center">
                {roundFormatPrice(Number(item.total_payable))}
              </td>
            )
          }

          <td className="table-text align-middle text-center">
            {checkDeliveryFilter ? item.delivery_boy_name : item.waiter_name}
          </td>

          <td className={`table-text align-middle text-center ${tableColor}`}>
            {checkDeliveryFilter ? item.delivery_address : item.table_name}
          </td>

          <td className="table-text text-capitalize align-middle text-center px-1" style={{minWidth: "22rem"}}>
            {itemListRowStatus(item, index)}
          </td>

          <td className="table-text align-middle text-center table_child_ordertype">
            {item.delivery_phn_no ? item.delivery_phn_no : "-"}
          </td>

          <td className="table-text align-middle text-center table_child_ordertype">
            {item.vehicle_no ? item.vehicle_no : "-"}
          </td>

          <td className="table-text align-middle text-center table_child_branch">
            <span className={parseInt(item.is_cancelled) ? "text-danger" : "text-primary"}>{getOrderStatus(item) || item?.order_status || item?.["order-status"] || "-"}</span>
          </td>

          <td className="table-text text-capitalize align-middle text-center table_child">
            {item.online_payment_method}
          </td>

          <td className="table-text text-capitalize align-middle text-center table_child_time">
            <Moment format="hh:mm:ss A">
              {item.created_at}
            </Moment>
          </td>

          <td className="table-text text-capitalize align-middle text-center table_child_token">
            <Moment format="LT">
              {item?.updated_at}
            </Moment>
          </td>

          {
            !checkDeliveryFilter && (
              <td className="table-text text-capitalize align-middle text-center table_child_token">
                {item?.delivery_boy_name ? item.delivery_boy_name : "-"}
              </td>
            )
          }
          
          <td className="table-text text-capitalize align-middle text-center">
            {item?.area_name ?? "-"}
          </td>

          <td className="table-text text-capitalize align-middle text-center table_child_token">
            {item?.delivery_boy_id &&
              item?.rider_status ? (
              <span
                className="btn btn-transparent btn-secondary xsm-text text-capitalize px-2 mr-2">
                {item.rider_status}
              </span>
            ) : "-"
            }
          </td>

          <td className="table-text text-capitalize align-middle text-center">
            {item?.ref_no ? item.ref_no : "-"}
          </td>

          {
            parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
              <td className="table-text text-capitalize align-middle text-center table_child_token">
                {item.order_no}
              </td>
            )
          }
          {
            authUserInfo.permissions !== null &&
            checkPermission(authUserInfo.permissions, "Submitted Amount") && (
              <>
                <td className="table-text text-capitalize align-middle text-center">
                  {item.service_charge}
                </td>
                <td className="table-text text-capitalize align-middle text-center">
                  {item.order_bill}
                </td>
              </>
            )
          }
          <td className="table-text text-capitalize align-middle text-center">
            {item.user_name}
          </td>
        </tr>
      </>
    );
  };

  const handleFOCSubmit = (checkOrderDetails) => {

    if (parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
      toast.error(`You can't foc advance booking order.`);
      return
    }

    if (authUserInfo.details?.manager_foc_limit) {

      if(!checkOrderDetails?.item){
        ToastError({title: "Can't multiSettle foc on manager limit"});
        return;
      }

      const workPeriod = workPeriodListForBranch &&
        workPeriodListForBranch.find((tempWorkPeriod) => {
          return (parseInt(checkOrderDetails?.item?.work_period_id) === parseInt(tempWorkPeriod.id)) && tempWorkPeriod.ended_at === null;
        })

      const payload = {
        dayOpenDate: workPeriod?.date,
        amount: checkOrderDetails?.item?.total_payable
      }

      const onSuccess = (mangerId) => {
        let orderGroup = {...checkOrderDetails?.item, id: [checkOrderDetails.item.id] }
        orderGroup.manager_id = mangerId
        handleFreeCostOrderConfirmation(orderGroup)
      };

      openFOCManagerModal(payload, onSuccess)
      return
    }

    if (checkOrderDetails?.item || (multiSettleOrder.orders && Object.keys(multiSettleOrder.orders)?.length)) {
      const orderGrp = {
        id: checkOrderDetails.item ? [checkOrderDetails.item.id] : Object.keys(multiSettleOrder.orders),
      }
      handleFreeCostOrderConfirmation(orderGrp);
      return
    }
    
    toast.error("Please select the order first before action");

  }

  const isDineInOrder = checkOrderDetails?.item && /dine(.*)in/i.test(checkOrderDetails.item?.order_type_name);

  const renderCustomerUpdateBtn = useCallback(() => {
    const item = checkOrderDetails?.item;

    if (!item) return null;
    if (item?.order_source?.toLowerCase() === "carhop") return null;
    if(item?.customer_name) return null;

    const isDineIn = item?.order_type_name?.match(/dine(.*)in/i);
    const isHold = item?.is_hold;

    if (isDineIn && !isHold) {
      return (
        <button
          type="button"
          className="submit-actionButton"
          onClick={() => setIsCustomerUpdateModal(true)}
        >
          <i className="fa fa-user-plus new-btn"></i>
        </button>
      );
    }

    return null;
  }, [checkOrderDetails,isCustomerUpdateModal]);

  return (
    <>
      <Helmet>
        <title>{_t(t("Submitted orders"))}</title>
      </Helmet>

      <div className={showSettle ? "d-none" : ""}>

        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              <div className="col-12 t-mb-30 mb-lg-0">
                {checkOrderDetails.uploading === true ? (
                  pageLoading()
                ) : (
                  <div className="t-bg-white ">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />
                    {/* spin loading ends */}
                    <div className="row gx-2 align-items-center t-pt-15 t-pb-15 t-pl-15 t-pr-15 t-shadow">
                      {/* <div className="col-5 t-mb-15">
                        <ul className="t-list fk-breadcrumb">
                          <li className="fk-breadcrumb__list">
                            <span className="t-link fk-breadcrumb__link text-capitalize">
                              {!searchedOrder.searched
                                ? _t(t("Submitted orders"))
                                : _t(t("Search Result"))}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-5 t-mb-15">
                        <span className="px-4 t-link fk-breadcrumb__link">
                          Filter By
                        </span>
                      </div> */}
                      <div
                        className="col-md-4 col-lg-4 t-mb-15 mb-md-0"
                        style={{ borderRight: "1px solid #D0D0D0" }}
                      >
                        <ul className="t-list fk-sort align-items-center mr-2">
                          <li className="fk-breadcrumb__list mr-3">
                            <span className="t-link fk-breadcrumb__link text-capitalize">
                              {_t(t("Submitted order"))}
                            </span>
                          </li>
                          <div className="input-group col">
                            <div className="search-input-wrapper table-search-new--pos">
                              <div className="input-icon-container">
                                <FaSearch className="search-icon" />
                                <input
                                  type="text"
                                  className="search-input"
                                  placeholder={
                                    _t(t(
                                      "Search by token, customer, branch, order type"
                                    )) + ".."
                                  }
                                  onChange={handleSearch}
                                  ref={searchInputRef}
                                />
                              </div>
                            </div>
                          </div>
                        </ul>
                      </div>
                      <div className="col-sm-7 col-md-6 col-lg-6">
                        <div className="d-flex px-2 align-items-center gx-2">
                          {
                            availableDeliveryTypes && availableDeliveryTypes?.map((orderType, index) => {
                              return (
                                <div key={index} className="mr-2">
                                  <div className="submit-filter">
                                    <img
                                      src={getOrderTypeImage(orderType?.name)}
                                      alt={orderType.name}
                                      width="20px"
                                      height="20px"
                                    />
                                    <input
                                      className={`${activebtn === orderType.name ? "active-btn" : ""} `}
                                      id={orderType.name}
                                      name={orderType.name}
                                      value={orderType.name}
                                      type="submit"
                                      onClick={(e) => {
                                        setActivebtn(e.target.name);
                                        handleSearch(e)
                                      }}
                                    />
                                  </div>
                                </div>
                              )
                            })
                          }
                          <div className="mr-2">
                            <input
                              className={`submit-filter ALL-btnSs ${activebtn === "all" ? "active-btn" : ""} `}
                              id="all"
                              name="all"
                              value="All"
                              type="submit"
                              onClick={(e) => {
                                setActivebtn(e.target.name)
                                handleSearch(e)
                              }}
                            />
                          </div>
                          <div className="mr-2">
                            <input
                              className={`submit-filter ALL-btnSs ${activebtn === "carhop" ? "active-btn" : ""} `}
                              id="carhop"
                              name="carhop"
                              value="Carhop"
                              type="submit"
                              onClick={(e) => {
                                setActivebtn(e.target.name)
                                handleSearch(e)
                              }}
                            />
                          </div>
                          <div className="mr-3">
                            <button onClick={() => setPaginatedSubmittedOrders(1)} className="btn btn-success rounded" title="Refresh orders">
                              <i className="fa fa-refresh" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-5 col-md-2 col-lg-2">
                        <div className="row align-items-center gx-2">
                          <div className="col-6">
                            <NavLink
                              to="/dashboard/pos"
                              className="t-link t-pt-10 t-pb-10 t-pl-12 t-pr-12 btn btn-secondary xsm-text text-uppercase text-center w-100 rounded"
                              style={{ backgroundColor: "#3170BF ", fontSize: ".75rem", fontWeight: 600 }}
                            >
                              {_t(t("POS"))}
                            </NavLink>
                          </div>
                          <div className="col-6">
                            <NavLink
                              to="/dashboard/pos/settled"
                              className="t-link t-pt-10 t-pb-10 t-pl-12 t-pr-12 btn btn-success xsm-text text-uppercase text-center w-100 rounded"
                              style={{ backgroundColor: "#4DCCA9 ", fontSize: ".75rem", fontWeight: 600 }}
                            >
                              {_t(t("Settled"))}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="fk-scroll--order-submitted" data-simplebar>
                      <div className="t-pl-15 t-pr-15">
                        <div className="">
                          <table className="table table-bordered table-hover min-table-height mt-4">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("S/L"))}
                                </th>

                                {multiOrderSettle ? (
                                  <th
                                    scope="col"
                                    className="table-text text-capitalize align-middle text-center border-1 border table_child_time"
                                  >
                                    {_t(t("Multi Settle"))}
                                    <div className="text-center">
                                      <label className="ml-2" onClick={(e) => e.stopPropagation()}>
                                        <span className="mr-1">Select All</span>
                                        <input
                                          id="multi_settle_check"
                                          type="checkbox"
                                          className="form-check-input"
                                          onChange={(e) => {
                                            toggleSelectAll(e);
                                          }}
                                        />
                                      </label>
                                    </div>
                                  </th>
                                ) : null}

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                                >
                                  {_t(t("Token"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Order Type"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_ordertype"
                                >
                                  {_t(t("Customer"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Branch"))}
                                </th>

                                {
                                  authUserInfo.permissions !== null &&
                                  checkPermission(authUserInfo.permissions, "Submitted Amount") && (
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table_child_total"
                                    >
                                      {_t(t("Total Amount"))}
                                    </th>
                                  )
                                }

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_total"
                                >
                                  {_t(t(checkDeliveryFilter ? "Rider" : "Waiter"))}
                                </th>

                                <th
                                  scope="col"
                                  className={`table-text text-capitalize align-middle text-center border-1 border ${checkDeliveryFilter ? "table_child_branch" : "table_child_total"}`}
                                >
                                  {_t(t(checkDeliveryFilter ? "Address" : "Table"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                  style={{minWidth: parseInt(getSystemSettings(generalSettings, "duplicate_kot")) === 1 ? "22rem" : "18rem"}}
                                >
                                  {_t(t("Status"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_ordertype"
                                >
                                  {_t(t("Customer Phone"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_ordertype"
                                >
                                  {_t(t("Vehicle No"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Order Status"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                                >
                                  {_t(t("Online Payment Method"))}
                                </th>
                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                                >
                                  {_t(t("Time"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Dispatch Time"))}
                                </th>

                                {
                                  !checkDeliveryFilter && (
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {_t(t("Rider Name"))}
                                    </th>
                                  )
                                }

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Area Name"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Rider Status"))}
                                </th>

                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Ref No"))}
                                </th>

                                {
                                  parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table_child_token"
                                    >
                                      {_t(t("Doc. No"))}
                                    </th>
                                  )
                                }
                                {
                                  authUserInfo.permissions !== null &&
                                  checkPermission(authUserInfo.permissions, "Submitted Amount") && (
                                    <>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        {_t(t("D. Charges"))}
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        {_t(t("Gross Amount"))}
                                      </th>
                                    </>
                                  )
                                }
                                <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("User Name"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {!searchedOrder.searched
                                ? [
                                  submittedOrders && submittedOrders?.data && [
                                    submittedOrders.data?.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="14"
                                          className="table-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      submittedOrders.data.map(
                                        (item, index) => {
                                          return itemListContent(item, index)
                                        }
                                      )
                                    ),
                                  ],
                                ]
                                : [
                                  /* searched data, logic === haveData*/
                                  searchedOrder && searchedOrder?.list && [
                                    searchedOrder.list?.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="8"
                                          className="table-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      searchedOrder.list.map(
                                        (item, index) => {
                                          return itemListContent(item, index)
                                        }
                                      )
                                    ),
                                  ],
                                ]}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                

                {/* settle buttons */}
                <div className="row m-0 px-1 t-bg-white my-1 t-pt-5 t-pb-5">
                  <div className="col-7 d-flex align-items-center">
                    {(checkOrderDetails?.item && parseInt(checkOrderDetails.item?.is_cancelled) === 0) || checkOrderDetails?.item === null ? (
                      <>
                      {/* table transfer */}
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Order Table Tranfer"
                          ) && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" ? (
                          isDineInOrder && (
                            <button
                              className="submit-actionButton mr-2"
                              disabled={checkOrderDetails?.item && !isDineInOrder}
                              onClick={() => {
                                if (checkOrderDetails?.item) {
                                  if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                    toast.error(`You can't edit ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                    return
                                  }
                                  if (parseInt(checkOrderDetails.item?.is_split) === 1) {
                                    toast.error(`You can't edit split order.`);
                                    return
                                  }
                                  history.push(
                                    `/dashboard/epos/${checkOrderDetails.item?.id}?table=${checkOrderDetails.item.table_name}`,
                                    { fromUrl: true }
                                  );
                                } else {
                                  toast.error("Please select the order first before action");
                                }
                              }}
                            >
                              Table Transfer
                            </button>
                          )
                        ) : ""}
                        {
                          editOrderPermission && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" ? (
                            <>
                              {isDineInOrder && (
                                  <>
                                    <button
                                      title="Table Merge"
                                      className="submit-actionButton mr-2"
                                      onClick={() => {
                                        if (checkOrderDetails?.item) {
                                          if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                            toast.error(`You can't edit ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                            return
                                          }
                                          if (parseInt(checkOrderDetails.item?.is_split) === 1) {
                                            toast.error(`You can't edit split order.`);
                                            return
                                          }
                                          history.push(
                                            `/dashboard/epos/${checkOrderDetails.item?.id}?table_merge=edit`,
                                            { fromUrl: true }
                                          );
                                        } else {
                                          toast.error(
                                            "Please select the order first before action"
                                          );
                                        }
                                      }}
                                    >
                                      TM
                                    </button>
                                    {
                                      checkOrderDetails?.item && !checkOrderDetails.item?.is_split && checkOrderDetails.item?.is_advance_booking !== 1 && (
                                        <button
                                          className="submit-actionButton mr-2"
                                          onClick={() => {
                                            if (checkOrderDetails?.item) {
                                              if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                                toast.error(`You can't split ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                                return
                                              }
                                              handleSplitBill(checkOrderDetails.item);
                                            } else {
                                              toast.error(
                                                "Please select the order first before action"
                                              );
                                            }
                                          }}
                                        >
                                          Bill Split
                                        </button>
                                      )
                                    }
                                  </>
                                )
                              }
                            </>
                          ) : (
                            ""
                          )
                        }

                        {/* change waiter */}
                        {isDineInOrder &&
                          parseInt(getSystemSettings(generalSettings, "enable_waiter_selection")) === 1 && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" ? (
                            <button
                              className="submit-actionButton mr-2"
                              onClick={() => {
                                if (checkOrderDetails?.item) {
                                  if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                    toast.error(`You can't change waiter ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                    return
                                  }
                                  if (parseInt(checkOrderDetails.item?.is_split) === 1) {
                                    toast.error(`You can't change waiter split order.`);
                                    return
                                  }
                                  handleWaiterChange(checkOrderDetails?.item)
                                } else {
                                  toast.error(
                                    "Please select the order first before action"
                                  );
                                }
                              }}
                            >
                              Change Waiter
                            </button>
                          ) : ""
                        }

                        {/* order cancel */}
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Order void"
                          ) ? (
                          <button
                            className="submit-actionButton mr-2"
                            onClick={() => {
                              if (checkOrderDetails?.item) {
                                handleCancelOrderConfirmation(checkOrderDetails?.item);
                              } else {
                                toast.error(
                                  "Please select the order first before action"
                                );
                              }
                            }}
                          >
                            Void Order
                          </button>
                        ) : (
                          ""
                        )}
                        {editOrderPermission && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" ? (
                          <>
                            {/* edit order */}
                            <button
                              className="submit-actionButton mr-2"
                              title="Recall/Edit"
                              onClick={() => {
                                if (checkOrderDetails?.item) {
                                  if (parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 0 && checkOrderDetails?.item?.party_name === "Website") {
                                    toast.error("Party for website only");
                                    return
                                  }
                                  if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                    toast.error(`You can't edit ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                    return
                                  }
                                  history.push(`/dashboard/epos/${checkOrderDetails.item?.id}`, { fromUrl: true });
                                } else {
                                  toast.error(
                                    "Please select the order first before action"
                                  );
                                }
                              }}
                            >
                              Edit
                            </button>
                            
                            {/* change order type */}
                            <button
                              title="Change Order Type"
                              className="submit-actionButton mr-2"
                              onClick={() => {
                                if (checkOrderDetails?.item) {
                                  if (onlineOdrEdit || parseInt(checkOrderDetails.item?.is_advance_booking) === 1) {
                                    toast.error(`You can't edit ${parseInt(checkOrderDetails.item?.is_advance_booking) === 1 ? "advance booking" : "online"} order.`);
                                    return
                                  }
                                  if (parseInt(checkOrderDetails.item?.is_split) === 1) {
                                    toast.error(`You can't edit split order.`);
                                    return
                                  }
                                  history.push(
                                    `/dashboard/epos/${checkOrderDetails.item?.id}`,
                                    { fromUrl: true }
                                  );
                                } else {
                                  toast.error(
                                    "Please select the order first before action"
                                  );
                                }
                              }}
                            >
                              COT
                            </button>
                          </>
                        ) : (
                          ""
                        )}

                        {/* Free Of Cost */}
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Free Of Cost"
                          ) && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" && ((checkOrderDetails?.item && checkOrderDetails.item?.order_type_name &&
                          parseInt(checkOrderDetails.item?.is_hold) === 0 && !checkOrderDetails.item.order_type_name?.match(/delivery/i)) || 
                          (multiSettleOrder.orders && Object.keys(multiSettleOrder.orders)?.length)) ? (
                          <div className="mr-2">
                            <button
                              title="Free Of Cost"
                              className="submit-actionButton"
                              onClick={() => handleFOCSubmit(checkOrderDetails)}
                            >
                              FOC
                            </button>
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Rider Assign */}
                        {authUserInfo.permissions !== null &&
                          checkPermission(
                            authUserInfo.permissions,
                            "Rider assign"
                          ) && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" && checkOrderDetails?.item && checkOrderDetails.item?.order_type_name && checkOrderDetails.item.order_type_name?.match(/delivery/i) ? (
                          !checkOrderDetails.item.is_hold && (
                            <div className="mr-2">
                              <button
                                title="assign rider"
                                className="submit-actionButton mr-2"
                                onClick={() => {
                                  if (checkOrderDetails?.item) {
                                    if (checkOrderDetails.item.delivery_boy_id && checkOrderDetails.item?.rider_status === "Pick Up") {
                                      toast.error("Rider already assigned");
                                    } else {
                                      setRiderModal(true);
                                      setDeliveryStatus(deliveryStatusOption[0]);
                                      let getDeliveryMan = null;
                                      if (checkOrderDetails.item.delivery_boy_id) {
                                        getDeliveryMan = deliveryListReqForSearch.find((delivery) => delivery.id === checkOrderDetails.item.delivery_boy_id)
                                      }
                                      setCheckOrderDetails({
                                        ...checkOrderDetails,
                                        delivery_man_id: getDeliveryMan,
                                        time_to_deliver: (checkOrderDetails.item?.time_to_deliver || checkOrderDetails.item?.theBranch?.delivery_time) ?? "",
                                      });
                                    }
                                  } else {
                                    toast.error("Please select the order first before action");
                                  }
                                }}
                              >
                                <img src="/assets/img/rider.png" style={{ height: "1.41rem" }} alt="" />
                              </button>
                            </div>
                          )

                        ) : (
                          ""
                        )}
                        {renderCustomerUpdateBtn()}

                        {/* multi settle */}
                        {
                          multiSettleOrder.orders && Object.keys(multiSettleOrder.orders)?.length && checkOrderDetails?.item?.order_source?.toLowerCase() !== "carhop" ? (
                            <div className="mr-2">
                              <button
                                className="submit-actionButton"
                                onClick={() => setMultiSettleOrder((curr) => ({ ...curr, modal: true }))}
                              >
                                Multi Settle
                              </button>
                            </div>
                          ) : ""
                        }
                      </>
                    ) : (
                      <div className="mr-2 d-flex align-items-center border border-1">
                        <h6 className="py-1 px-3 lg-text my-0"> Not Allowed </h6>
                      </div>
                    )}
                  </div>
                  {/* Checkbox Filters Footer */}
                  <div className="d-flex justify-content-end align-items-center col-3">
                    {
                      ["web", "pos", "app"].map(type => (
                        <div key={type} className="d-flex align-items-center ml-2 p-1 px-2 rounded cursor-pointer" 
                          style={{fontSize: "0.92rem", backgroundColor: getBackgroundColor(type, true), 
                          border:  filterTypes[type] ? `2px solid ${getCheckboxColor(type)}` : `1px solid ${getCheckboxColor(type)}`,
                          transition: "transform 0.3s ease-in-out"
                        }}
                          onClick={() => setFilterTypes(prev => ({...prev, [type]: !prev[type]}))}
                        >
                          <div style={{width: 10, height: 10, backgroundColor: getCheckboxColor(type), marginRight: 5, borderRadius: 2}}></div>
                          <span className="text-capitalize font-weight-bold" style={{color: getCheckboxColor(type), userSelect: 'none'}}>
                            {type} ({typeCounts[type] || 0})
                          </span>
                        </div>
                      ))
                    }
                    {/* {(() => {
                      return 
                    })()} */}
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end position-relative">
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Submitted Amount") && (
                        <>
                          {showTotal && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '110%',
                                right: "0.8rem",
                                background: 'white',
                                border: '1px solid #ccc',
                                zIndex: 999,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                width: "88.5%"
                              }}
                              className="p-2 rounded d-flex flex-column"
                            >
                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary mb-1 rounded-sm"
                              >
                                Gross: {roundOffPrice(g_gross)}
                              </button>
                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary mb-1 rounded-sm"
                              >
                                Discount: {roundOffPrice(g_discount)}
                              </button>
                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary mb-1 rounded-sm"
                              >
                                After dis: {roundOffPrice(g_after_dis)}
                              </button>
                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary mb-1 rounded-sm"
                              >
                                Tax: {roundOffPrice(g_tax)}
                              </button>
                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary mb-1 rounded-sm"
                              >
                                D.Charge: {roundOffPrice(g_delivery)}
                              </button>

                              <button
                                type="button"
                                className="w-100 table-text btn btn-sm btn-secondary rounded-sm"
                              >
                                Cancel: {roundOffPrice(g_cancel)}
                              </button>
                            </div>
                          )}
                          <button
                            type="button"
                            style={{ width: "99%" }}
                            className="d-flex align-items-center table-text btn btn-sm btn-secondary rounded-sm"
                            onClick={() => setShowTotal(!showTotal)}
                          >
                            <span style={{ width: "92%" }}>
                              Total: {roundOffPrice(g_total)}
                            </span>
                            <TiArrowSortedUp className="text-white" />
                          </button>
                        </>
                      )
                    }
                  </div>
                </div>
                {/* pagination loading effect */}
                {checkOrderDetails.uploading === true || loading === true ? (
                  paginationLoading()
                ) : (
                  <>
                    <div
                      key="fragment4"
                      className={`t-bg-white mt-1 t-pt-5 t-pb-5 ${
                        searchedOrder.searched ? "d-none" : ""
                      }`}
                    >
                      <div className="row align-items-center t-pl-15 t-pr-15">
                        <div className="col-md-7 t-mb-15 mb-md-0">
                          {/* pagination function */}
                          {pagination(
                            submittedOrders,
                            setPaginatedSubmittedOrders
                          )}
                        </div>
                        <div className="col-md-5">
                          <ul className="t-list d-flex justify-content-md-end align-items-center">
                            <li className="t-list__item">
                              <span className="d-inline-block sm-text">
                                {showingData(submittedOrders)}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {searchedOrder.searched && (
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={onSearchClear}
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedOrder,
                                    submittedOrdersForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* show settle  */}
      <div
        className={`fk-settle-container d-flex flex-column justify-content-center ${showSettle ? "" : "d-none"
          }`}
      >
        <CustomSpinLoader loading={loading || dataPaginating} />
        <div className="fk-settle">
          <div className="container-fluid">
            <div className="row gx-3">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="d-flex justify-content-between px-2">
                  <div className="table-text d-block text-capitalize font-weight-bold py-3">
                    {_t(t("Settle order"))}  {checkOrderDetails?.item && checkOrderDetails?.item?.table_name && checkOrderDetails?.item?.table_name !== "-" && ` (Table: ${checkOrderDetails?.item?.table_name})`}
                  </div>
                  <div className="table-text d-block text-capitalize font-weight-bold py-3">
                    {checkOrderDetails?.item && checkOrderDetails?.item?.branch_name}
                  </div>
                </div>
                <div
                  className="fk-settle__products d-flex flex-column"
                  data-simplebar
                >
                  <div className="container-fluid">
                    <div className="row gx-3">
                      <div className="col-12">
                        {/* POS Product list will be here  */}
                        <div className="fk-price-table__body t-mt-10">
                          <div className="fk-price-table__body-top">
                            <div className="fk-table">
                              <div className="t-pb-30">
                                <div className="col-12 filtr-item">
                                  <div className="fk-order-token t-bg-white">
                                    <div className="fk-order-token__body">
                                      <div className="fk-addons-table">
                                        <div className="d-flex justify-content-between px-3 fk-addons-table__head">
                                          <div className="mr-3">
                                            {_t(t("order token"))} -
                                            {checkOrderDetails.item &&
                                              checkOrderDetails.item.token?.id}
                                          </div>
                                          <div>
                                            {`${checkOrderDetails?.item && checkOrderDetails?.item?.order_type_name} - ${checkOrderDetails?.item && checkOrderDetails?.item?.party_name}`}
                                          </div>
                                        </div>
                                        <div className="fk-addons-table__info">
                                          <div className="row g-0">
                                            <div className="col-2 text-center border-right">
                                              <span className="fk-addons-table__info-text text-capitalize">
                                                {_t(t("S/L"))}
                                              </span>
                                            </div>
                                            <div className="col-3 text-center border-right">
                                              <span className="fk-addons-table__info-text text-capitalize">
                                                {_t(t("food"))}
                                              </span>
                                            </div>
                                            <div className="col-4 text-left pl-2 border-right">
                                              <span className="fk-addons-table__info-text text-capitalize">
                                                {_t(t("Additional Info"))}
                                              </span>
                                            </div>
                                            <div className="col-2 text-center">
                                              <span className="fk-addons-table__info-text text-capitalize">
                                                {_t(t("QTY"))}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        {checkOrderDetails.item &&
                                          (checkOrderDetails.item?.orderedItems || []).map(
                                            (thisItem, indexThisItem) => {
                                              return (
                                                <div key={indexThisItem} className="fk-addons-table__body-row">
                                                  <div className="row g-0">
                                                    <div className="col-2 text-center border-right d-flex">
                                                      <span className="fk-addons-table__info-text text-capitalize m-auto">
                                                        {indexThisItem + 1}
                                                      </span>
                                                    </div>
                                                    <div className="col-3 text-center border-right d-flex">
                                                      <span className={`fk-addons-table__info-text text-capitalize m-auto ${thisItem?.indolj_item_id ? "text-danger" : ""}`}>
                                                        {thisItem.food_item} (
                                                        {thisItem.food_group})
                                                        {thisItem?.indolj_item_id ? (
                                                          "⭐ "
                                                        ) : ""}
                                                      </span>
                                                    </div>
                                                    <div className="col-4 text-center border-right t-pl-10 t-pr-10">
                                                      {thisItem.variation !==
                                                        null && (
                                                          <span className="fk-addons-table__info-text text-capitalize d-block text-left t-pt-5">
                                                            <span className="font-weight-bold mr-1">
                                                              {_t(t("variation"))}
                                                              :
                                                            </span>
                                                            {thisItem.variation}
                                                          </span>
                                                        )}

                                                      {thisItem.properties !==
                                                        null && (
                                                          <span className="fk-addons-table__info-text text-capitalize d-block text-left t-pb-5">
                                                            <span className="font-weight-bold mr-1">
                                                              {_t(
                                                                t("properties")
                                                              )}
                                                              :
                                                            </span>
                                                            {JSON.parse(
                                                              thisItem.properties
                                                            ).map(
                                                              (
                                                                propertyItem,
                                                                thisIndex
                                                              ) => {
                                                                if (
                                                                  thisIndex !==
                                                                  JSON.parse(
                                                                    thisItem.properties
                                                                  ).length -
                                                                  1
                                                                ) {
                                                                  return (
                                                                    propertyItem.property +
                                                                    `${propertyItem.quantity >
                                                                      1
                                                                      ? "(" +
                                                                      propertyItem.quantity +
                                                                      ")"
                                                                      : ""
                                                                    }` +
                                                                    ", "
                                                                  );
                                                                } else {
                                                                  return (
                                                                    propertyItem.property +
                                                                    `${propertyItem.quantity >
                                                                      1
                                                                      ? "(" +
                                                                      propertyItem.quantity +
                                                                      ")"
                                                                      : ""
                                                                    }`
                                                                  );
                                                                }
                                                              }
                                                            )}
                                                          </span>
                                                        )}
                                                    </div>
                                                    <div className="col-2 text-center d-flex">
                                                      <span className="fk-addons-table__info-text text-capitalize m-auto">
                                                        {thisItem.quantity}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row gx-3">
                  <div className="col-md-9">
                    {returnMoneyUsd > 0 ? (
                      <div
                        className="alert alert-danger text-center"
                        style={{ height: "56px", marginTop: "16px" }}
                      >
                        Return Amount: {roundFormatPrice(returnMoneyUsd)}
                      </div>
                    ) : (
                      <>
                        {
                          getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none" && (
                            <>
                              {
                                getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? (
                                  <div className="fk-settle-group t-mt-10 row">
                                    <div className="col-6">
                                      <div className="table-text font-weight-bold cursor-pointer text-center d-flex">
                                        {
                                          loyaltyPoint.availablePoints > 0 ? (
                                            <button disabled={getDisableLoyality() || loyaltyPoint.qr_code} title="send otp to customer" className={`toggle-option p-2 table-text rounded-left ${loyaltyPoint.type === "send-otp" ? "active" : "text-white bg-warning"}`} onClick={() => handleToggle("send-otp")}>SendOtp</button>
                                          ) : (
                                            <button title="get customer info" className={`toggle-option p-2 table-text rounded-left ${loyaltyPoint.type === "get-info" ? "active" : ""}`} onClick={() => handleToggle("get-info")}>Get Info</button>
                                          )
                                        }
                                        <button disabled={getDisableLoyality()} title="redeem points by code" className={`toggle-option p-2 table-text rounded-right ${loyaltyPoint.type === "code" ? "active" : ""}`} onClick={() => handleToggle("code")}>Code</button>
                                        <input
                                          disabled={loyaltyPoint.type !== "code" || (checkOrderDetails.payment_type && checkOrderDetails.payment_type?.length)}
                                          type="text"
                                          onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                          onWheel={(e) => e.target.blur()}
                                          autocomplete="off"
                                          value={loyaltyPoint.qr_code}
                                          name="qr_code"
                                          style={{ minHeight: "1rem", color: "#121053" }}
                                          className="form-control ml-2 w-50 fk-settle-group__input px-2 font-weight-bold p-1 rounded-sm"
                                          placeholder="Code here..."
                                          onChange={(e) => handleGetLoyaltyChange(e)}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-6 pl-0 d-flex">
                                      <input
                                        disabled={loyaltyPoint.type !== "get-info" || (checkOrderDetails.payment_type && checkOrderDetails.payment_type?.length)}
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        value={loyaltyPoint.phn_no}
                                        name="phn_no"
                                        style={{ minHeight: "1rem", color: "#121053" }}
                                        className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Phone here..."
                                        onChange={(e) => handleGetLoyaltyChange(e)}
                                      />
                                      <input
                                        disabled
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                        className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Your points"
                                        value={loyaltyPoint.availablePoints}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="fk-settle-group t-mt-10 row">
                                    <div className="col-6">
                                      <div className="table-text font-weight-bold cursor-pointer text-center d-flex">
                                        <button title="redeem points by code" className={`toggle-option p-2 rounded-left ${loyaltyPoint.type === "token" ? "active" : ""}`} onClick={() => handleToggle("token")}>Loyalty</button>
                                        <button disabled={getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise"} title="new registration with phone" className={`toggle-option p-2 rounded-right ${loyaltyPoint.type === "phone" ? "active" : ""}`} onClick={() => handleToggle("phone")}>{getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise" ? "Get Items" : "loyalty Reg."}</button>
                                        <img title="loyalty points" style={{ marginLeft: "0.3rem", height: "2.25rem" }} src={LoyaltyImg} alt="loyalty points" />
                                      </div>
                                    </div>
                                    <div className="col-6 pl-0 d-flex">
                                      <input
                                        disabled={(checkOrderDetails.payment_type && checkOrderDetails.payment_type?.length) || (checkOrderDetails.item && checkOrderDetails.item?.party_name.toLowerCase() === "website")}
                                        type="text"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        autocomplete={loyaltyPoint.type === "phone" ? "on" : "off"}
                                        value={loyaltyPoint.qr_code}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053" }}
                                        className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                        placeholder={loyaltyPoint.type === "phone" ? "Phone here..." : "Code here..."}
                                        onChange={(e) => handleGetIndoljChange(e)}
                                      />
                                      <input
                                        disabled
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                        className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Your points"
                                        value={loyaltyPoint.availablePoints}
                                      />
                                    </div>
                                  </div>
                                )
                              }
                              <div className="fk-settle-group row t-mt-10">
                                <div className="col-6">
                                  <label
                                    htmlFor="settle-paid-amount"
                                    className="text-capitalize fk-settle-group__label font-weight-bold d-flex align-items-center justify-content-between"
                                  >
                                    redeem amount:
                                    <button title="clear to unlock redeem" className="text-end px-2 btn btn-sm btn-danger rounded" onClick={() => handleClearAll()}>Unlock</button>
                                  </label>
                                </div>
                                <div className="col-6 pl-0 d-flex">
                                  <input
                                    disabled
                                    type="text"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    value={loyaltyPoint.maxRedeemPoints ? loyaltyPoint.maxRedeemPoints + " Points" : ""}
                                    style={{ minHeight: "1rem", color: "#121053" }}
                                    className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                  />
                                  <input
                                    disabled={!loyaltyPoint.verified || (checkOrderDetails.payment_type && checkOrderDetails.payment_type?.length) || (getSystemSettings(generalSettings, "loyality_enable") === "indolj" && checkOrderDetails.item && checkOrderDetails.item?.party_name.toLowerCase() === "website")}
                                    type="number"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    id="settle-total"
                                    style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                    className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                    max={loyaltyPoint.availablePoints}
                                    value={loyaltyPoint.redeemPoints || ""}
                                    onChange={(e) => handleRedeemPoint(e)}
                                  />
                                </div>
                              </div>
                            </>
                          )
                        }
                        <div className="fk-settle-group d-flex align-items-center t-mt-10">
                          <label
                            htmlFor="settle-total"
                            className="text-capitalize w-50 fk-settle-group__label font-weight-bold"
                          >
                            Total:
                          </label>
                          <div
                            id="settle-total"
                            className="w-50 fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                          >
                            {checkOrderDetails &&
                              checkOrderDetails.item &&
                              (parseFloat(checkOrderDetails.item.total_payable) -
                                parseFloat(checkOrderDetails.item.paid_amount))
                            }
                          </div>
                        </div>
                        <div className="fk-settle-group d-flex align-items-center t-mt-10 t-mb-15">
                          <label
                            htmlFor="settle-paid-amount"
                            className="text-capitalize w-50 fk-settle-group__label font-weight-bold"
                          >
                            Paid Amount:
                          </label>
                          {/* { paySelected ? (
                              <div
                                id="settle-total"
                                className="w-50 fk-settle-group__input text-right pr-2 font-weight-bold"
                              >
                                {paidMoney}
                              </div>
                            ) : (
                              )
                            } */}
                            <input
                              ref={inputRefs.paid}
                              type="number"
                              onKeyDown={(evt) => ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) && evt.preventDefault()}
                              onWheel={(e) => e.target.blur()}  
                              id="settle-total"
                              style={{minHeight:"1rem",color:"#121053"}}
                              autoFocus
                              className="form-control w-50 fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                              key={paidMoney}
                              value={paidMoney ?? ""}
                              onChange={(e) => setPaidMoney(e.target.value ? parseFloat(e.target.value) : 0)}
                            />
                        </div>
                      </>
                    )}
                    <div className={`${getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none" ? "fk-settle-cal-loyality" : "fk-settle-cal"} container-fluid`}>
                      <div className="row h-100 g-2 mt-1">
                        <div className="col-2">
                          <div className="row g-2 h-100">
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 10);
                                  }
                                }}
                              >
                                10
                              </button>
                            </div>
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 20);
                                  }
                                }}
                              >
                                20
                              </button>
                            </div>
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 50);
                                  }
                                }}
                              >
                                50
                              </button>
                            </div>
                            <div className="col-12 mb-2">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 100);
                                  }
                                }}
                              >
                                100
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="row g-2 h-100">
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 1) : 1);
                                      }
                                    }}
                                  >
                                    1
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 4) : 4);
                                      }
                                    }}
                                  >
                                    4
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 7) : 7);
                                      }
                                    }}
                                  >
                                    7
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 500);
                                      }
                                    }}
                                  >
                                    500
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 2) : 2);
                                      }
                                    }}
                                  >
                                    2
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 5) : 5);
                                      }
                                    }}
                                  >
                                    5
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 8) : 8);
                                      }
                                    }}
                                  >
                                    8
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 1000);
                                      }
                                    }}
                                  >
                                    1000
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 3) : 3);
                                      }
                                    }}
                                  >
                                    3
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 6) : 6);
                                      }
                                    }}
                                  >
                                    6
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 9) : 9);
                                      }
                                    }}
                                  >
                                    9
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 5000);
                                      }
                                    }}
                                  >
                                    5000
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-text-white t-bg-ac text-capitalize"
                                    onClick={() => {
                                      if (
                                        checkOrderDetails &&
                                        checkOrderDetails.item
                                      ) {
                                        let theP = parseFloat(
                                          roundOffPrice(
                                            checkOrderDetails.item
                                              .total_payable -
                                            checkOrderDetails.item.paid_amount
                                          )
                                        );
                                        setPaidMoney(theP);
                                      }
                                    }}
                                  >
                                    all
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-text-white t-bg-ac text-capitalize"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        // if (
                                        //   checkOrderDetails &&
                                        //   checkOrderDetails.item
                                        // ) {
                                        //   let theP = formatPrice(
                                        //     parseFloat(
                                        //       (checkOrderDetails.item
                                        //         .total_payable -
                                        //         checkOrderDetails.item
                                        //           .paid_amount) /
                                        //         2
                                        //     )
                                        //   );
                                        //   setPaidMoney(parseFloat(theP));
                                        // }
                                        setPaidMoney(paidMoney > 0 && (String(paidMoney) + 0));
                                      }
                                    }}
                                  >
                                    0
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-d t-text-white"
                                    onClick={() => {
                                      handleClearAmount()
                                    }}
                                  >
                                    C
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn bg-primary t-text-white t-bg-r text-capitalize"
                                    onClick={(e) => {
                                      if (!loading) {
                                        handleSettleOrder(e)
                                      }
                                    }}
                                  >
                                    {!loading ? _t(t("settle")) : _t(t("wait"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex flex-column justify-content-center t-mt-15">
                      <div className="fk-settle__pay" data-simplebar>
                        <div className="row gx-3">
                          <div className="col-12">
                            {/* POS Navigation will ber here */}
                            <ul className="t-list fk-pos-nav list-group">
                              <li className="fk-pos-nav__list">
                                {
                                  loyaltyPoint.customerName && (
                                    <div className="w-100 mb-3 font-weight-md text-truncate">
                                      {loyaltyPoint.customerName}
                                    </div>
                                  )
                                }
                                <div className="w-100 mb-3 d-flex align-items-center">
                                  <label className="mr-2">Tip:</label>
                                  <input
                                    type="number"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control fk-settle-group__input py-1 px-2 font-weight-bold"
                                    autoFocus
                                    value={checkOrderDetails.item?.order_tip || ""}
                                    onChange={(e) => setCheckOrderDetails({ ...checkOrderDetails, item: { ...checkOrderDetails.item, order_tip: e.target.value } })}
                                  />
                                </div>
                                <button
                                  type="button"
                                  onClick={() => handleGoBack()}
                                  className="w-100 t-text-dark t-heading-font btn alert alert-danger font-weight-bold text-uppercase py-3 mb-3"
                                >
                                  Go back
                                </button>
                              </li>
                              {/* paymentTypes */}
                              {paymentTypeAvailable &&
                                paymentTypeAvailable.map(
                                  (groupItem, groupIndex) => {
                                    return (
                                      <li
                                        className="fk-pos-nav__list"
                                        key={groupIndex}
                                      >
                                        <button
                                          type="button"
                                          disabled={(checkOrderDetails.item && checkOrderDetails.item?.online_payment_method && checkOrderDetails.item?.online_payment_method !== "-"
                                            && groupItem?.prefix) ? !groupItem.prefix.toLowerCase().includes(checkOrderDetails.item?.online_payment_method.toLowerCase()) : false}
                                          //set active or
                                          className={`w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase py-3 ${checkOrderDetails &&
                                            checkOrderDetails.payment_type !== null &&
                                            checkOrderDetails.payment_type[0].id === groupItem.id
                                            ? "active"
                                            : ""
                                            }`}
                                          onClick={() => {
                                            handleSetpaymentTypeSingle(
                                              groupItem
                                            );
                                          }}
                                        >
                                          {groupItem.name}
                                        </button>
                                      </li>
                                    );
                                  }
                                )}
                              {/*split paymentTypes */}
                              {paymentTypeAvailable &&
                                paymentTypeAvailable?.length > 1 && (
                                  <li className="mt-2" title="Clear Paid Amount for Split Payment">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setPayModal(true);
                                        handleClearAll();
                                      }}
                                      className="w-100 t-text-dark t-heading-font btn alert alert-danger font-weight-bold text-uppercase py-3 mb-3"
                                    >
                                      Split Payment
                                    </button>
                                  </li>
                                )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*made unmade item cancel order*/}
      <ItemCancelModal
        deleteReasonModalShowing={deleteReasonModalShowing}
        handleCancelEmpty={handleCancelEmpty}
        itemToDelete={itemToDelete}
        passcodeApplied={passcodeApplied}
        handleCancelOrderReasonSubmit={handleCancelOrderReasonSubmit}
      />

      {/* rider assign modal */}
      <RiderModal
        riderModal={riderModal}
        setRiderModal={setRiderModal}
        setCheckOrderDetails={setCheckOrderDetails}
        handleRider={handleRider}
        setDeliveryStatus={setDeliveryStatus}
        deliveryStatus={deliveryStatus}
        deliveryStatusOption={deliveryStatusOption}
        checkOrderDetails={checkOrderDetails}
      />

      {/*split pay modal */}
      <SplitPayment
        handleClick={handleClick}
        totalsettle={checkOrderDetails.item && parseFloat(checkOrderDetails.item.total_payable) - parseFloat(checkOrderDetails.item.paid_amount)}
        payModal={payModal}
        handleSetPayment={handleSetPayment}
        paySelected={paySelected}
        paymentTypeAvailable={paymentTypeAvailable}
        payment={payment}
        handleSetpaymentTypeMuliple={handleSetpaymentTypeMuliple}
        handleSplitPayment={handleSplitPayment}
      />

      {/* waiter modal */}
      <WaiterChangeModal
        changeWaiter={changeWaiter}
        setChangeWaiter={setChangeWaiter}
        handleWaiterChangeApi={handleWaiterChangeApi}
      />

      {/* Card Modal */}
      <CardModal
        cardAdd={cardAdd}
        handleCardSubmit={handleCardSubmit}
        inputRefs={inputRefs}
        cardNumber={cardNumber}
        handleCardChange={handleCardChange}
        bank_required={Number((paySelected || checkOrderDetails.payment_type?.[0])?.bank_required) === 1}
      />

      {/*multi settle */}
      <MultiSettleModal
        multiSettleOrder={multiSettleOrder}
        setMultiSettleOrder={setMultiSettleOrder}
        setSearchedOrder={setSearchedOrder}
        roundFormatPrice={roundFormatPrice}
      />

      {/* order print */}
      <OrderPrintView
        componentRef={componentRef}
        checkOrderDetails={checkOrderDetails}
        taxType={taxType}
        taxPercent={taxPercent}
        isSettle={isSettle}
        fbrInvoiceNum={fbrInvoiceNum}
        srbInvoiceNum={{
          number: srbInvoiceNum.number,
          url: srbInvoiceNum.url,
        }}
        paidMoney={paidMoney}
        foodGroupsToPrint={foodGroupsToPrint}
        component2Ref={component2Ref}
        isSubmitted={1}
        redeemPoints={loyaltyPoint.redeemPoints || (checkOrderDetails.item && checkOrderDetails.item?.redeem_points)}
        availablePoints={loyaltyPoint.availablePoints || (checkOrderDetails.item && checkOrderDetails.item?.available_points)}
        earnedPoints={loyaltyPoint.earnedPoints || (checkOrderDetails.item && checkOrderDetails.item?.earned_points)}
      />
      {/* order view*/}
      <OrderDetailsView
        checkOrderDetails={checkOrderDetails}
        returnMoneyUsd={returnMoneyUsd}
        paidMoney={paidMoney}
        handleSettleOrder={handleSettleOrder}
        handleSetpaymentType={handleSetpaymentType}
        handlePaymentTypeAmount={handlePaymentTypeAmount}
        setCheckOrderDetails={setCheckOrderDetails}
        setReturnMoneyUsd={setReturnMoneyUsd}
        setPaidMoney={setPaidMoney}
        setTotalAmount={setTotalAmount}
        printLocation="Submitted Order"
        redeemPoints={loyaltyPoint.redeemPoints || (checkOrderDetails.item && checkOrderDetails.item?.redeem_points)}
      />
      {/* split bill */}
      <SplitBill
        splitBill={splitBill}
        setSplitBill={setSplitBill}
        taxType={taxType}
        setBillModal={setBillModal}
        billModal={billModal}
        onSearchClear={onSearchClear}
      />

      {/* customer update modal */}
      <OrderCustomerDetail
        orderDetails={checkOrderDetails}
        isCustomerUpdateModal={isCustomerUpdateModal}
        setIsCustomerUpdateModal={setIsCustomerUpdateModal}
        onCallBackSuccess={(customer) => {
          // Settle screen: keep settle open and sync customerInfo for settle-submitted-order
          if (checkOrderDetails?.settle) {
            setCheckOrderDetails((curr) => ({
              ...curr,
              item: {
                ...curr.item,
                customer_id: customer?.id ?? curr.item?.customer_id ?? null,
                customer_name: customer?.name || "",
                customer_phn_no: customer?.phn_no || "",
                delivery_phn_no: customer?.phn_no || "",
                email: customer?.email || "",
                customer_email: customer?.email || "",
                delivery_address: customer?.address || "",
                customer_address: customer?.address || "",
              },
            }));
            return;
          }

          // List screen: refresh list and clear selection
          setPaginatedSubmittedOrders(1);
          setCheckOrderDetails({
            item: null,
            payment_amount: null,
            payment_type: null,
            settle: false,
            uploading: false,
            card_number: "",
            order_payment_bank: null,
          });
        }}
      />

      {/* Print Payment Type Modal */}
      <PrintPaymentModal
        printPaymentModalItem={printPaymentModalItem}
        setPrintPaymentModalItem={setPrintPaymentModalItem}
        paymentTypeAvailable={paymentTypeAvailable}
        handlePrint={handlePrint}
      />

      {/* Update Delivery Charge Modal */}
      <UpdateDeliveryChargeModal
        deliveryChargeModalItem={deliveryChargeModalItem}
        setDeliveryChargeModalItem={setDeliveryChargeModalItem}
        setPaginatedSubmittedOrders={setPaginatedSubmittedOrders}
      />

      {/* Update Device Token Modal */}
      <UpdateDeviceTokenModal
        deviceTokenModalItem={deviceTokenModalItem}
        setDeviceTokenModalItem={setDeviceTokenModalItem}
        setPaginatedSubmittedOrders={setPaginatedSubmittedOrders}
      />
    </>
  );
};

export default Submitted;
